// // =======================================FULL EDIT FORM======================================================
// // import React, { useEffect, useState, useRef } from "react";
// // import axios from "axios";
// // import { useNavigate, useParams } from "react-router-dom";
// // import Select, { components } from "react-select";
// // import { toast } from "react-toastify";

// // const CampaignScheduleEditForm = () => {
// //   const navigate = useNavigate();
// //   const { id } = useParams();
// //   const inputRefs = useRef([]);
// //   const [loading, setLoading] = useState(true);

// //   // States
// //   const [campaignDetails, setCampaignDetails] = useState("");
// //   const [campaignName, setCampaignName] = useState("");
// //   const [campaignType, setCampaignType] = useState("");
// //   const [scheduleDate, setScheduleDate] = useState("");
// //   const [audience, setAudience] = useState("");
// //   const [audienceCount, setAudienceCount] = useState(0);
// //   const [startDate, setStartDate] = useState(
// //     new Date().toISOString().split("T")[0]
// //   );

// //   const [endDate, setEndDate] = useState(startDate);
// //   const [campaignBatchId, setCampaignBatchId] = useState("");
// //   const [batchIds, setBatchIds] = useState([]);
// //   const [channelSelected, setChannelSelected] = useState(false);
// //   const [selectedChannelId, setSelectedChannelId] = useState("");
// //   const [selectedChannelConnectionName, setSelectedChannelConnectionName] =
// //     useState("");
// //   const [messageType, setMessageType] = useState("");

// //   const [selectedTemplateId, setSelectedTemplateId] = useState("");

// //   const [templateVariables, setTemplateVariables] = useState({});
// //   const [templateButtonVariables, setTemplateButtonVariables] = useState({});
// //   const [templateHeadersList, setTemplateHeadersList] = useState({
// //     inputvariables: [],
// //     buttonvariables: [],
// //   });
// //   const [templateHeaderVariables, setTemplateHeaderVariables] = useState("");
// //   const [templateHeaderImage, setTemplateHeaderImage] = useState("");
// //   const [templateHeaderVideo, setTemplateHeaderVideo] = useState("");
// //   const [templateHeaderDocument, setTemplateHeaderDocument] = useState("");
// //   const [templateMessage, setTemplateMessage] = useState("");
// //   const [templateList, setTemplateList] = useState([]);
// //   const [channelList, setChannelList] = useState([]);
// //   const [dropdownOpen, setDropdownOpen] = useState(null);

// //   const [batchData, setBatchData] = useState([]);

// //   const predefinedOptions = ["{{name}}", "{{email}}", "{{phone}}"];
// //   const [predefinedTemplates, setPredefinedTemplates] = useState([]);

// //   useEffect(() => {
// //     const fetchPredefinedTemplates = async () => {
// //       try {
// //         const response = await axios.get("/api/predefinedtemplate/getall");
// //         console.log(response);
// //         setPredefinedTemplates(response.data.data);
// //       } catch (error) {
// //         console.error("Failed to fetch predefined templates:", error);
// //       }
// //     };

// //     fetchPredefinedTemplates();
// //   }, []);

// //   const fetchBatchDetails = async (campaignId) => {
// //     try {
// //       const response = await axios.get(
// //         `/api/campaignscheduler/getcampaign/${campaignId}`
// //       );
// //       if (response.status === 200) {
// //         setAudienceCount(response.data.length);
// //         setBatchData(response.data);
// //       } else {
// //         console.error("Failed to fetch Audience");
// //       }
// //     } catch (error) {
// //       console.error("Error fetching batch details:", error);
// //     }
// //   };

// //   useEffect(() => {
// //     const fetchCampaignData = async () => {
// //       try {
// //         const response = await axios.get(
// //           `/api/campaignscheduler/get_campaign_scheduler/${id}`
// //         );
// //         const data = response.data;
// //         console.log(data);

// //         setCampaignDetails(data.campaignDetails || "");
// //         setCampaignName(data.campaignName || "");
// //         setCampaignType(data.campaignType || "");
// //         setScheduleDate(data.scheduleDate || "");
// //         setAudience(data.audience || "");
// //         setStartDate(data.startDate || new Date().toISOString().split("T")[0]);
// //         setCampaignBatchId(data.campaignBatchId || "");
// //         setChannelSelected(data.channelSelected || false);
// //         setSelectedChannelId(data.selectedChannelId || "");
// //         setSelectedChannelConnectionName(
// //           data.selectedChannelConnectionName || ""
// //         );
// //         setMessageType(data.messageType || "");
// //         setTemplateVariables(data.templateVariables || {});
// //         setTemplateButtonVariables(data.templateButtonVariables || {});
// //         // setTemplateMessage(data.templateHeadersList.data.name || "");
// //         setTemplateMessage(data.templateHeadersList.data.id || "");
// //         setTemplateHeadersList(
// //           data.templateHeadersList || {
// //             inputvariables: [],
// //             buttonvariables: [],
// //           }
// //         );
// //         setTemplateHeaderVariables(data.updatedHeaderText || "");
// //         setTemplateHeaderImage(data.updatedHeaderImage || "");
// //         setTemplateHeaderVideo(data.updatedHeaderVideo || "");
// //         setTemplateHeaderDocument(data.updatedHeaderDocument || "");

// //         // ✅ Pass preselected batch ID to avoid overwriting
// //         await fetchBatchIds(data.startDate, data.campaignBatchId);
// //       } catch (error) {
// //         toast.error("Unable to load campaign data for duplication");
// //       }
// //     };

// //     fetchCampaignData();
// //   }, [id]);

// //   console.log(messageType);
// //   console.log(templateMessage);

// //   const fetchBatchIds = async (date, preselectedBatchId = "") => {
// //     try {
// //       const isoDate = new Date(date).toISOString().split("T")[0];
// //       const response = await axios.get(
// //         `/api/campaignscheduler/getfiltercampaign`,
// //         {
// //           params: { startDate: isoDate, endDate: date },
// //         }
// //       );

// //       if (response.status === 200) {
// //         const batchList = response.data.contact;
// //         setBatchIds(batchList);

// //         // ✅ Only set default if there's no preselected value
// //         if (!preselectedBatchId) {
// //           const firstBatchId =
// //             batchList.length > 0 && batchList[0] !== "No campaigns available"
// //               ? batchList[0]
// //               : "";
// //           setCampaignBatchId(firstBatchId);

// //           if (firstBatchId) {
// //             fetchBatchDetails(firstBatchId);
// //           }
// //         } else {
// //           // If we already have a preselected one, just fetch its details
// //           fetchBatchDetails(preselectedBatchId);
// //         }
// //       } else {
// //         console.error("Failed to fetch batch IDs:", response.data.message);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching batch IDs:", error);
// //     }
// //   };

// //   const fetchChannelData = async () => {
// //     try {
// //       const response = await axios.get("/api/campaignscheduler/getallchannel");
// //       setChannelList(response.data);
// //       // console.log("Channel List :", response.data);
// //     } catch (error) {
// //       console.error("Failed to fetch channels:", error);
// //     }
// //   };

// //   const fetchChannelListData = async () => {
// //     try {
// //       const response = await axios.get(
// //         "/api/campaignscheduler/getallchannellist"
// //       );
// //       setChannelList(response.data);
// //       // console.log("Channel List :", response.data);
// //     } catch (error) {
// //       console.error("Failed to fetch channels:", error);
// //     }
// //   };

// //   useEffect(() => {
// //     if (campaignDetails === "WA Cloud") {
// //       fetchChannelData();
// //     } else if (campaignDetails === "WA Team") {
// //       fetchChannelListData();
// //     }
// //   }, [campaignDetails]);

// //   const [visibleOptions, setVisibleOptions] = useState(7);

// //   const options = templateList.map((template) => ({
// //     value: template.id,
// //     label: `${template.name} - 🟢${template.status} - 🟠${template.category}`,
// //   }));

// //   const MenuList = (props) => {
// //     const { children } = props;

// //     // Normal options + See More button
// //     return (
// //       <components.MenuList {...props}>
// //         {children}
// //         {options.length > visibleOptions && (
// //           <div
// //             style={{
// //               padding: "8px",
// //               textAlign: "center",
// //               cursor: "pointer",
// //               color: "blue",
// //               fontWeight: "500",
// //             }}
// //             onClick={(e) => {
// //               e.stopPropagation(); // prevent selecting
// //               setVisibleOptions((prev) => prev + 7);
// //             }}
// //           >
// //             See More
// //           </div>
// //         )}
// //       </components.MenuList>
// //     );
// //   };

// //   const fetchTemplateList = async () => {
// //     if (!selectedChannelId || templateList.length > 0) return;

// //     setLoading(true);
// //     try {
// //       const response = await axios.get(
// //         `/api/campaignscheduler/${selectedChannelId}/getalltemplateapproved`
// //       );
// //       setTemplateList(response.data);
// //       console.log("Template List :", response.data);
// //     } catch (error) {
// //       console.error("Failed to fetch templates:", error);
// //       alert("Failed to fetch templates Cloud. Please try again later.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const fetchTemplateListVersionTwo = async () => {
// //     if (!selectedChannelId) return;

// //     setLoading(true);
// //     try {
// //       const response = await axios.get(
// //         `/api/campaignscheduler/${selectedChannelId}/getalltemplateapprovedversiontwo`
// //       );
// //       setTemplateList(response.data);
// //       console.log("Template List Version Two :", response.data);
// //     } catch (error) {
// //       console.error("Failed to fetch templates:", error);
// //       alert("Failed to fetch templates V2. Please try again later.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (selectedChannelId) {
// //       if (campaignDetails === "WA Cloud") {
// //         fetchTemplateList();
// //       } else if (campaignDetails === "WA Team") {
// //         fetchTemplateListVersionTwo();
// //       }
// //     }
// //   }, [selectedChannelId]);

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     const formData = {
// //       campaignDetails,
// //       campaignName,
// //       campaignType,
// //       scheduleDate: campaignType === "Immediate" ? "" : scheduleDate,
// //       audience,
// //       startDate,
// //       campaignBatchId,
// //       channelSelected,
// //       selectedChannelId,
// //       selectedChannelConnectionName,
// //       messageType,
// //       templateVariables,
// //       templateButtonVariables,
// //       templateMessage,
// //       templateHeadersList,
// //       templateHeaderVariables,
// //       templateHeaderImage,
// //       templateHeaderVideo,
// //       updatedTemplateText: updatedTemplateText,
// //       updatedTemplateButton: updatedTemplateButton,
// //       updatedHeaderText: updatedHeaderText,
// //       updatedHeaderImage: updatedHeaderImage,
// //       updatedHeaderVideo: updatedHeaderVideo,
// //       updatedHeaderDocument: updatedHeaderDocument,
// //       templateHeaderDocument,
// //     };

// //     console.log(formData);

// //     try {
// //       const response = await axios.put(
// //         `/api/campaignscheduler/update_campaign_scheduler/${id}`,
// //         formData
// //       );
// //       if (response.status === 201 || response.status === 200) {
// //         toast.success("Campaign updated successfully!");
// //         navigate(-1);
// //       }
// //     } catch (error) {
// //       toast.error("Failed to update campaign. Try again!");
// //     }
// //   };

// //   // Handlers for form fields
// //   const handleCampaignDetailsChange = (e) => setCampaignDetails(e.target.value);
// //   const handleCampaignNameChange = (e) => setCampaignName(e.target.value);
// //   const handleCampaignTypeChange = (e) => setCampaignType(e.target.value);
// //   const handleScheduleDateChange = (e) => setScheduleDate(e.target.value);
// //   const handleAudienceChange = (e) => setAudience(e.target.value);
// //   // const handleDateChange = (e) => setStartDate(e.target.value);

// //   const handleDateChange = async (e) => {
// //     const date = e.target.value;
// //     setStartDate(date);
// //     setEndDate(date);

// //     if (date) {
// //       fetchBatchIds(date);
// //     }
// //   };

// //   const handleBatchChange = async (event) => {
// //     const campaignId = event.target.value;
// //     setCampaignBatchId(campaignId);

// //     if (campaignId) {
// //       fetchBatchDetails(campaignId);
// //     }
// //   };

// //   const handleChannelChange = (e) => {
// //     const channelData = JSON.parse(e.target.value);
// //     setSelectedChannelId(channelData.id);
// //     setSelectedChannelConnectionName(channelData.name);
// //     setChannelSelected(true);
// //   };
// //   const handleMessageTypeChange = (e) => setMessageType(e.target.value);
// //   // const handleTemplateHeadersChange = (e) => setTemplateMessage(e.target.value);

// //   const handleTemplateHeadersChange = (event) => {
// //     const templateId = event.target.value;
// //     setSelectedTemplateId(templateId);
// //   };

// //   const handlePredefinedTemplateSelect = (templateId) => {
// //     const selectedTemplate = predefinedTemplates.find(
// //       (template) => template._id === templateId
// //     );

// //     if (selectedTemplate) {
// //       const values = selectedTemplate.predefinedtemplate || [];

// //       const headerVarCount = templateHeadersList.headervariables.length || 0;
// //       const bodyVarCount = templateHeadersList.inputvariables.length || 0;
// //       const buttonVarCount = templateHeadersList.buttonvariables?.length || 0;

// //       const headerVars = {};
// //       const bodyVars = {};
// //       const buttonVars = {};

// //       let index = 0;

// //       // Fill HEADER VARIABLES first
// //       for (let i = 0; i < headerVarCount; i++) {
// //         headerVars[i] = values[index] || "";
// //         index++;
// //       }

// //       // Fill BODY VARIABLES next
// //       for (let i = 0; i < bodyVarCount; i++) {
// //         bodyVars[i] = values[index] || "";
// //         index++;
// //       }

// //       // Fill BUTTON VARIABLES last
// //       for (let i = 0; i < buttonVarCount; i++) {
// //         buttonVars[i] = values[index] || "";
// //         index++;
// //       }

// //       setTemplateHeaderVariables(headerVars);
// //       setTemplateVariables(bodyVars);
// //       setTemplateButtonVariables(buttonVars);
// //     }
// //   };

// //   // const handleHeaderVariableChange = (index, value) => {
// //   //   setTemplateHeaderVariables((prev) => ({ ...prev, [index]: value }));
// //   // };

// //   const handleHeaderVariableChange = (value) => {
// //     setTemplateHeaderVariables(value);
// //   };
// //   const handleHeaderImageChange = (e) => setTemplateHeaderImage(e.target.value);
// //   const handleHeaderVideoChange = (e) => setTemplateHeaderVideo(e.target.value);

// //   const handleHeaderDocumentChange = (e) =>
// //     setTemplateHeaderDocument(e.target.value);

// //   const handleInsertVariableChange = (index, value) => {
// //     setTemplateVariables((prev) => ({ ...prev, [index]: value }));
// //   };

// //   const handleInsertText = (index, value) => {
// //     setTemplateVariables((prev) => ({
// //       ...prev,
// //       [index]: (prev[index] || "") + value,
// //     }));
// //     setDropdownOpen(null);
// //   };

// //   const handleButtonVariableChange = (index, value) => {
// //     setTemplateButtonVariables((prev) => ({ ...prev, [index]: value }));
// //   };

// //   const getUpdatedTemplateText = () => {
// //     // Replace placeholders in templateText with corresponding values from templateVariables
// //     let updatedText = templateHeadersList.templateText;
// //     console.log(templateHeadersList.inputvariables);
// //     templateHeadersList.inputvariables.forEach((variable, index) => {
// //       const placeholder = new RegExp(`\\{\\{${index + 1}\\}\\}`, "g"); // Match {{1}}, {{2}}, etc.
// //       updatedText = updatedText.replace(
// //         placeholder,
// //         templateVariables[index] || variable
// //       ); // Replace with input value or leave placeholder
// //     });
// //     // console.log("UpdatedText", updatedText);
// //     return updatedText;
// //   };

// //   const getUpdatedTemplateButton = () => {
// //     if (!templateHeadersList || !Array.isArray(templateHeadersList.buttons)) {
// //       console.error(
// //         "Error: templateHeadersList.buttons is undefined or not an array."
// //       );
// //       return [];
// //     }

// //     let updatedButtons = templateHeadersList.buttons.map(
// //       (button, buttonIndex) => {
// //         let updatedButton = { ...button };

// //         if (
// //           updatedButton.url &&
// //           Array.isArray(templateHeadersList.buttonvariables)
// //         ) {
// //           // Each button gets its index-mapped value from templateButtonVariables
// //           const variable = templateHeadersList.buttonvariables[buttonIndex]; // Get the corresponding placeholder
// //           if (variable) {
// //             const replacementValue = templateButtonVariables[buttonIndex] ?? ""; // Map to templateButtonVariables index

// //             updatedButton.url = updatedButton.url.replace(
// //               variable,
// //               replacementValue
// //             );
// //           }
// //         }

// //         return updatedButton;
// //       }
// //     );

// //     return updatedButtons;
// //   };

// //   const getUpdatedHeaderText = () => {
// //     let updatedHeaderText = templateHeadersList?.headerText || "";

// //     if (Array.isArray(templateHeadersList?.headervariables)) {
// //       templateHeadersList.headervariables.forEach((variable, index) => {
// //         const placeholder = new RegExp(`\\{\\{${index + 1}\\}\\}`, "g");
// //         updatedHeaderText = updatedHeaderText.replace(
// //           placeholder,
// //           templateHeaderVariables || variable
// //         );
// //       });
// //     }

// //     return updatedHeaderText;
// //   };

// //   const getUpdatedHeaderImage = () => {
// //     // console.log("Template Header List", templateHeadersList.headerImageUrl);
// //     let updatedHeaderImage = templateHeadersList.headerImageUrl;

// //     // Directly replace headerImageUrl with user input from templateHeaderImage
// //     if (templateHeaderImage) {
// //       updatedHeaderImage = templateHeaderImage;
// //     }

// //     // console.log("updatedHeaderImage", updatedHeaderImage);
// //     return updatedHeaderImage;
// //   };

// //   const getUpdatedHeaderVideo = () => {
// //     // console.log("Template Header List", templateHeadersList.headerVideoUrl);
// //     let updatedHeaderVideo = templateHeadersList.headerVideoUrl;

// //     // Directly replace headerImageUrl with user input from templateHeaderVideo
// //     if (templateHeaderVideo) {
// //       updatedHeaderVideo = templateHeaderVideo;
// //     }

// //     // console.log("updatedHeaderImage", updatedHeaderVideo);
// //     return updatedHeaderVideo;
// //   };

// //   const getUpdatedHeaderDocument = () => {
// //     // console.log("Template Header List", templateHeadersList.headerPdfUrl);
// //     let updatedHeaderDocument = templateHeadersList.headerPdfUrl;

// //     // Directly replace headerImageUrl with user input from templateHeaderDocument
// //     if (templateHeaderDocument) {
// //       updatedHeaderDocument = templateHeaderDocument;
// //     }

// //     // console.log("updatedHeaderDocument", updatedHeaderDocument);
// //     return updatedHeaderDocument;
// //   };

// //   const updatedTemplateText = getUpdatedTemplateText();
// //   const updatedTemplateButton = getUpdatedTemplateButton();
// //   const updatedHeaderText = getUpdatedHeaderText();
// //   const updatedHeaderImage = getUpdatedHeaderImage();
// //   const updatedHeaderVideo = getUpdatedHeaderVideo();
// //   const updatedHeaderDocument = getUpdatedHeaderDocument();

// //   useEffect(() => {
// //     if (templateList.length > 0 && templateMessage) {
// //       handleTemplateHeadersChange({ target: { value: templateMessage } });
// //     }
// //   }, [templateList, templateMessage]);

// //   useEffect(() => {
// //     const fetchTemplateHeaders = async () => {
// //       if (!selectedTemplateId || !selectedChannelId) return; // Only fetch if both are selected
// //       console.log(selectedTemplateId);
// //       try {
// //         const response = await axios.get(
// //           `/api/campaignscheduler/${selectedChannelId}/gettemplate/${selectedTemplateId}`
// //         );
// //         setTemplateHeadersList(response.data || []);
// //       } catch (error) {
// //         console.error("Failed to fetch template headers:", error);
// //       }
// //     };

// //     fetchTemplateHeaders();
// //   }, [selectedChannelId, selectedTemplateId]);

// //   return (
// //     <div className="page-content w-100">
// //       <div className="container mt-5">
// //         <div className="row">
// //           <div className="col-12 d-flex justify-content-between align-items-center">
// //             <h4>Campaign Scheduler Edit Form</h4>
// //             <button
// //               className="btn btn-secondary btn-sm"
// //               onClick={() => navigate(-1)}
// //             >
// //               &larr; Back
// //             </button>
// //           </div>
// //         </div>

// //         <div className="row mt-4">
// //           <div className="col-lg-12">
// //             <div className="card shadow-sm">
// //               <div className="card-body">
// //                 <form onSubmit={handleSubmit}>
// //                   <div className="d-flex gap-3 flex-column">
// //                     <div
// //                       className="d-flex gap-2"
// //                       style={{
// //                         padding: "10px 15px",
// //                       }}
// //                     >
// //                       {/* Campaign Details */}
// //                       <div
// //                         className="mx-auto"
// //                         style={{
// //                           padding: "10px 15px",
// //                           width: "33.33%",
// //                         }}
// //                       >
// //                         <div className="mb-2">
// //                           <label className="form-label fw-bold">
// //                             Campaign Details:
// //                           </label>
// //                           <div className="d-flex gap-3 mt-2">
// //                             <div className="form-check">
// //                               <input
// //                                 className="form-check-input"
// //                                 type="radio"
// //                                 name="campaignDetailsOptions"
// //                                 id="campaignDetails1"
// //                                 value="WA Cloud"
// //                                 checked={campaignDetails === "WA Cloud"}
// //                                 onChange={handleCampaignDetailsChange}
// //                               />
// //                               <label
// //                                 className="form-check-label"
// //                                 htmlFor="campaignDetails1"
// //                               >
// //                                 WA Cloud
// //                               </label>
// //                             </div>
// //                             <div className="form-check">
// //                               <input
// //                                 className="form-check-input"
// //                                 type="radio"
// //                                 name="campaignDetailsOptions"
// //                                 id="campaignDetails2"
// //                                 value="WA Team"
// //                                 checked={campaignDetails === "WA Team"}
// //                                 onChange={handleCampaignDetailsChange}
// //                               />
// //                               <label
// //                                 className="form-check-label"
// //                                 htmlFor="campaignDetails2"
// //                               >
// //                                 WA Team
// //                               </label>
// //                             </div>
// //                           </div>
// //                         </div>
// //                       </div>
// //                       {/* Campaing Name */}
// //                       <div
// //                         className="mx-auto"
// //                         style={{
// //                           padding: "10px 15px",
// //                           width: "33.33%",
// //                         }}
// //                       >
// //                         <div className="mb-2">
// //                           <label
// //                             className="form-label fw-bold"
// //                             htmlFor="campaignName"
// //                           >
// //                             Campaign Name:
// //                           </label>
// //                           <input
// //                             type="text"
// //                             id="campaignName"
// //                             className="form-control"
// //                             placeholder="Enter Campaign Name"
// //                             value={campaignName}
// //                             onChange={handleCampaignNameChange}
// //                           />
// //                         </div>
// //                       </div>
// //                       {/* Campaign Type */}
// //                       <div
// //                         className="mx-auto"
// //                         style={{
// //                           padding: "10px 15px",
// //                           width: "33.33%",
// //                         }}
// //                       >
// //                         <div className="mb-2">
// //                           <label className="form-label fw-bold">
// //                             Campaign Type:
// //                           </label>
// //                           <div>
// //                             <div className="d-flex gap-3 mt-2">
// //                               <div className="form-check">
// //                                 <input
// //                                   className="form-check-input"
// //                                   type="radio"
// //                                   name="campaignTypeOptions"
// //                                   id="campaignType1"
// //                                   value="Immediate"
// //                                   checked={campaignType === "Immediate"}
// //                                   onChange={handleCampaignTypeChange}
// //                                 />
// //                                 <label
// //                                   className="form-check-label"
// //                                   htmlFor="campaignType1"
// //                                 >
// //                                   Immediate
// //                                 </label>
// //                               </div>
// //                               <div className="form-check">
// //                                 <input
// //                                   className="form-check-input"
// //                                   type="radio"
// //                                   name="campaignTypeOptions"
// //                                   id="campaignType2"
// //                                   value="Schedule"
// //                                   checked={campaignType === "Schedule"}
// //                                   onChange={handleCampaignTypeChange}
// //                                 />
// //                                 <label
// //                                   className="form-check-label"
// //                                   htmlFor="campaignType2"
// //                                 >
// //                                   Schedule
// //                                 </label>
// //                               </div>
// //                             </div>

// //                             {campaignType === "Schedule" && (
// //                               <div className="mt-2">
// //                                 <label
// //                                   htmlFor="dateTimeSelect"
// //                                   className="form-label"
// //                                 >
// //                                   Schedule Date & Time:
// //                                 </label>
// //                                 <input
// //                                   type="datetime-local"
// //                                   className="form-control"
// //                                   id="dateTimeSelect"
// //                                   // value={scheduleDate}
// //                                   value={new Date(scheduleDate)
// //                                     .toLocaleString("sv-SE", {
// //                                       timeZone: "Asia/Kolkata",
// //                                     })
// //                                     .replace(" ", "T")}
// //                                   onChange={handleScheduleDateChange}
// //                                 />
// //                               </div>
// //                             )}
// //                           </div>
// //                         </div>
// //                       </div>
// //                     </div>
// //                     <div
// //                       className="d-flex gap-2"
// //                       style={{
// //                         padding: "10px 15px",
// //                       }}
// //                     >
// //                       <div
// //                         className="mx-auto"
// //                         style={{
// //                           width: "40%",
// //                           padding: "10px 15px",
// //                         }}
// //                       >
// //                         <div className="mb-2">
// //                           <div>
// //                             <label className="form-label fw-bold">
// //                               Audience: {audienceCount}
// //                             </label>
// //                           </div>
// //                           <div>
// //                             <div className="d-flex gap-3 mt-1">
// //                               <div className="form-check">
// //                                 <input
// //                                   className="form-check-input"
// //                                   type="radio"
// //                                   name="AudienceOptions"
// //                                   id="Audience1"
// //                                   value="All Contacts"
// //                                   checked={audience === "All Contacts"}
// //                                   onChange={handleAudienceChange}
// //                                 />
// //                                 <label
// //                                   className="form-check-label"
// //                                   htmlFor="Audience1"
// //                                 >
// //                                   All Contacts from CRM
// //                                 </label>
// //                               </div>
// //                               <div className="form-check">
// //                                 <input
// //                                   className="form-check-input"
// //                                   type="radio"
// //                                   name="AudienceOptions"
// //                                   id="Audience2"
// //                                   value="Segmented"
// //                                   checked={audience === "Segmented"}
// //                                   onChange={handleAudienceChange}
// //                                 />
// //                                 <label
// //                                   className="form-check-label"
// //                                   htmlFor="Audience2"
// //                                 >
// //                                   Segmented
// //                                 </label>
// //                               </div>
// //                             </div>

// //                             {audience === "Segmented" && (
// //                               <div className="d-flex gap-3 mt-3">
// //                                 <div className="mt-3">
// //                                   <label
// //                                     htmlFor="dateSelect"
// //                                     className="form-label"
// //                                   >
// //                                     Campaign Date:
// //                                   </label>
// //                                   <input
// //                                     type="date"
// //                                     className="form-control"
// //                                     id="dateSelect"
// //                                     // value={startDate}

// //                                     value={new Date(
// //                                       startDate
// //                                     ).toLocaleDateString("sv-SE", {
// //                                       timeZone: "Asia/Kolkata",
// //                                     })}
// //                                     onChange={handleDateChange}
// //                                   />
// //                                 </div>

// //                                 <div className="mt-3">
// //                                   <label
// //                                     htmlFor="batchSelect"
// //                                     className="form-label"
// //                                   >
// //                                     Campaign Batch ID:
// //                                   </label>

// //                                   <select
// //                                     id="batchSelect"
// //                                     className="form-select"
// //                                     value={campaignBatchId || ""}
// //                                     onChange={handleBatchChange}
// //                                     disabled={!batchIds.length}
// //                                   >
// //                                     {batchIds.length ? (
// //                                       <>
// //                                         <option value="" disabled>
// //                                           Select an option
// //                                         </option>
// //                                         {batchIds.map((id) => (
// //                                           <option key={id} value={id}>
// //                                             {id}
// //                                           </option>
// //                                         ))}
// //                                       </>
// //                                     ) : (
// //                                       <option value="" disabled>
// //                                         No batch IDs found
// //                                       </option>
// //                                     )}
// //                                   </select>
// //                                 </div>
// //                               </div>
// //                             )}
// //                           </div>
// //                         </div>
// //                       </div>
// //                       <div
// //                         className="mx-auto"
// //                         style={{
// //                           width: "60%",
// //                           padding: "10px 15px",
// //                         }}
// //                       >
// //                         <div className="mb-2">
// //                           <div>
// //                             <label className="form-label fw-bold">
// //                               Template:
// //                             </label>
// //                           </div>
// //                           <div>
// //                             <div className="d-flex gap-5 align-items-center">
// //                               <label
// //                                 htmlFor="channelSelect"
// //                                 className="form-label"
// //                               >
// //                                 Channel:
// //                               </label>
// //                               <select
// //                                 id="channelSelect"
// //                                 className="form-select"
// //                                 aria-label="Select a channel"
// //                                 onChange={handleChannelChange}
// //                                 // disabled={campaignDetails !== "WA Cloud"}
// //                                 disabled={
// //                                   !(
// //                                     campaignDetails === "WA Cloud" ||
// //                                     campaignDetails === "WA Team"
// //                                   )
// //                                 }
// //                                 value={
// //                                   selectedChannelId
// //                                     ? JSON.stringify({
// //                                         id: selectedChannelId,
// //                                         name: selectedChannelConnectionName,
// //                                       })
// //                                     : ""
// //                                 }
// //                               >
// //                                 <option value="" disabled selected>
// //                                   Select an option
// //                                 </option>
// //                                 {channelList.map((channel) => (
// //                                   <option
// //                                     key={channel._id}
// //                                     value={JSON.stringify({
// //                                       id: channel._id,
// //                                       name: channel.connectionname,
// //                                     })}
// //                                   >
// //                                     {channel.connectionname}
// //                                   </option>
// //                                 ))}
// //                               </select>
// //                             </div>

// //                             {channelSelected && (
// //                               <div className="mt-3">
// //                                 <label
// //                                   htmlFor="channelSelect"
// //                                   className="form-label"
// //                                 >
// //                                   Message Type:
// //                                 </label>
// //                                 <div className="d-flex gap-5 mt-2">
// //                                   <div className="form-check">
// //                                     <input
// //                                       className="form-check-input"
// //                                       type="radio"
// //                                       name="TemplateOptions"
// //                                       id="template1"
// //                                       value="Pre-Approved"
// //                                       checked={messageType === "Pre-Approved"}
// //                                       onChange={handleMessageTypeChange}
// //                                     />
// //                                     <label
// //                                       className="form-check-label"
// //                                       htmlFor="template1"
// //                                     >
// //                                       Pre-Approved Template
// //                                     </label>
// //                                   </div>
// //                                   <div className="form-check">
// //                                     <input
// //                                       className="form-check-input"
// //                                       type="radio"
// //                                       name="TemplateOptions"
// //                                       id="template2"
// //                                       value="Regular Message"
// //                                       checked={
// //                                         messageType === "Regular Message"
// //                                       }
// //                                       onChange={handleMessageTypeChange}
// //                                     />
// //                                     <label
// //                                       className="form-check-label"
// //                                       htmlFor="template2"
// //                                     >
// //                                       Regular Message
// //                                     </label>
// //                                   </div>
// //                                 </div>
// //                               </div>
// //                             )}

// //                             {messageType === "Pre-Approved" && (
// //                               <div className="mt-3">
// //                                 <label
// //                                   htmlFor="templateSelect"
// //                                   className="form-label"
// //                                 >
// //                                   Template:
// //                                 </label>
// //                                 <Select
// //                                   inputId="templateSelect"
// //                                   // options={options}
// //                                   options={options.slice(0, visibleOptions)}
// //                                   components={{ MenuList }}
// //                                   // onChange={(selectedOption) =>
// //                                   //   handleTemplateHeadersChange({
// //                                   //     target: { value: selectedOption.value },
// //                                   //   })
// //                                   // }
// //                                   onChange={(selectedOption) => {
// //                                     // state update karo
// //                                     setTemplateMessage(selectedOption.value);

// //                                     // Reset niche ka form
// //                                     setTemplateHeaderVariables([]);
// //                                     setTemplateHeaderImage(null);
// //                                     setTemplateHeaderVideo(null);
// //                                     setTemplateHeaderDocument(null);
// //                                     setTemplateVariables([]);
// //                                     setTemplateButtonVariables([]);

// //                                     // agar aapko pehle se defined function bhi chalana hai
// //                                     handleTemplateHeadersChange({
// //                                       target: { value: selectedOption.value },
// //                                     });
// //                                   }}
// //                                   value={
// //                                     options.find(
// //                                       (opt) => opt.value === templateMessage
// //                                     ) || null
// //                                   }
// //                                   placeholder="Select a template..."
// //                                   isSearchable
// //                                   isLoading={templateList.length === 0}
// //                                 />
// //                               </div>
// //                             )}

// //                             {/* Dynamic Input Boxes */}
// //                             {templateHeadersList.inputvariables &&
// //                               templateHeadersList.inputvariables.length > 0 && (
// //                                 <div className="d-flex gap-3 mt-4">
// //                                   <div
// //                                     className="input_variables"
// //                                     style={{
// //                                       maxWidth: "40%",
// //                                     }}
// //                                   >
// //                                     {/* PREDEFINED TEMPLATES SELECT */}
// //                                     <select
// //                                       className="form-select mb-3"
// //                                       onChange={(e) =>
// //                                         handlePredefinedTemplateSelect(
// //                                           e.target.value
// //                                         )
// //                                       }
// //                                     >
// //                                       <option value="" disabled selected>
// //                                         Select pre-template
// //                                       </option>
// //                                       {predefinedTemplates.map((template) => (
// //                                         <option
// //                                           key={template._id}
// //                                           value={template._id}
// //                                         >
// //                                           {template.templatename}
// //                                         </option>
// //                                       ))}
// //                                     </select>

// //                                     {/* HEADER INPUTS BASED ON headerFormat */}
// //                                     {templateHeadersList.headerFormat ===
// //                                       "TEXT" &&
// //                                       templateHeadersList.headervariables.map(
// //                                         (variable, index) => (
// //                                           <div className="mb-3" key={index}>
// //                                             <label
// //                                               htmlFor={`templateVariable-${index}`}
// //                                               className="form-label"
// //                                             >
// //                                               {`HEADER VARIABLE #${index + 1}`}
// //                                             </label>
// //                                             <input
// //                                               type="text"
// //                                               id={`templateVariable-${index}`}
// //                                               className="form-control"
// //                                               placeholder={`Enter value for ${variable}`}
// //                                               value={
// //                                                 templateHeaderVariables || ""
// //                                               }
// //                                               onChange={(e) =>
// //                                                 handleHeaderVariableChange(
// //                                                   e.target.value
// //                                                 )
// //                                               }
// //                                             />
// //                                           </div>
// //                                         )
// //                                       )}

// //                                     {templateHeadersList.headerFormat ===
// //                                       "IMAGE" && (
// //                                       <div className="mb-3">
// //                                         <label
// //                                           htmlFor="headerImageUpload"
// //                                           className="form-label"
// //                                         >
// //                                           HEADER IMAGE:
// //                                         </label>
// //                                         <input
// //                                           type="text"
// //                                           id="headerImageUpload"
// //                                           className="form-control"
// //                                           placeholder="Enter image URL"
// //                                           value={templateHeaderImage || ""}
// //                                           onChange={handleHeaderImageChange}
// //                                         />
// //                                       </div>
// //                                     )}

// //                                     {templateHeadersList.headerFormat ===
// //                                       "VIDEO" && (
// //                                       <div className="mb-3">
// //                                         <label
// //                                           htmlFor="headerVideoUpload"
// //                                           className="form-label"
// //                                         >
// //                                           HEADER VIDEO:
// //                                         </label>
// //                                         <input
// //                                           type="text"
// //                                           id="headerVideoUpload"
// //                                           className="form-control"
// //                                           placeholder="Enter video URL"
// //                                           value={templateHeaderVideo || ""}
// //                                           onChange={handleHeaderVideoChange}
// //                                         />
// //                                       </div>
// //                                     )}

// //                                     {templateHeadersList.headerFormat ===
// //                                       "DOCUMENT" && (
// //                                       <div className="mb-3">
// //                                         <label
// //                                           htmlFor="headerDocumentUpload"
// //                                           className="form-label"
// //                                         >
// //                                           HEADER DOCUMENT:
// //                                         </label>
// //                                         <input
// //                                           type="text"
// //                                           id="headerDocumentUpload"
// //                                           className="form-control"
// //                                           placeholder="Enter document URL"
// //                                           value={templateHeaderDocument || ""}
// //                                           onChange={handleHeaderDocumentChange}
// //                                         />
// //                                       </div>
// //                                     )}

// //                                     {/* BODY INPUT BOXES */}

// //                                     {templateHeadersList.inputvariables.map(
// //                                       (variable, index) => (
// //                                         <div
// //                                           className="mb-3 position-relative"
// //                                           key={index}
// //                                         >
// //                                           <label className="form-label">{`BODY VARIABLE #${
// //                                             index + 1
// //                                           }`}</label>
// //                                           <div className="input-container">
// //                                             {/* Input Field */}
// //                                             <input
// //                                               type="text"
// //                                               ref={(el) =>
// //                                                 (inputRefs.current[index] = el)
// //                                               }
// //                                               className="form-control custom-input"
// //                                               placeholder={`Enter value for ${variable}`}
// //                                               value={
// //                                                 templateVariables[index] || ""
// //                                               }
// //                                               onChange={(e) =>
// //                                                 handleInsertVariableChange(
// //                                                   index,
// //                                                   e.target.value
// //                                                 )
// //                                               }
// //                                             />

// //                                             {/* Dropdown Icon Inside Input Field */}
// //                                             <span
// //                                               className="custom-dropdown-icon"
// //                                               onClick={() =>
// //                                                 setDropdownOpen(
// //                                                   dropdownOpen === index
// //                                                     ? null
// //                                                     : index
// //                                                 )
// //                                               }
// //                                             >
// //                                               &lt;&gt;
// //                                             </span>

// //                                             {/* Dropdown Inside Input Field */}
// //                                             {dropdownOpen === index && (
// //                                               <div className="custom-dropdown">
// //                                                 {predefinedOptions.map(
// //                                                   (option, idx) => (
// //                                                     <div
// //                                                       key={idx}
// //                                                       className="dropdown-item"
// //                                                       onClick={() =>
// //                                                         handleInsertText(
// //                                                           index,
// //                                                           option
// //                                                         )
// //                                                       }
// //                                                     >
// //                                                       {option}
// //                                                     </div>
// //                                                   )
// //                                                 )}
// //                                               </div>
// //                                             )}
// //                                           </div>
// //                                         </div>
// //                                       )
// //                                     )}

// //                                     <style>
// //                                       {`
// //                                         .input-container {
// //                                           position: relative;
// //                                           display: flex;
// //                                           align-items: center;
// //                                         }

// //                                         .custom-input {
// //                                           width: 100%;
// //                                           padding-right: 35px; /* Space for the dropdown icon */
// //                                         }

// //                                         .custom-dropdown-icon {
// //                                           position: absolute;
// //                                           right: 5px;
// //                                           bottom: 5px;
// //                                           cursor: pointer;
// //                                           font-size: 16px;

// //                                           padding: 3px 6px;

// //                                           user-select: none;
// //                                         }

// //                                         .custom-dropdown-icon:hover {
// //                                           font-weight: bold;

// //                                         }

// //                                         .custom-dropdown {
// //                                           position: absolute;
// //                                           bottom: -300%; /* Display below input field */
// //                                           right: 0px; /* Align to right inside input */
// //                                           background: white;
// //                                           border: 1px solid #ddd;
// //                                           border-radius: 4px;
// //                                           box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
// //                                           width: 138px;
// //                                           z-index: 10;
// //                                         }

// //                                         .dropdown-item {
// //                                           padding: 8px;
// //                                           cursor: pointer;
// //                                           transition: background 0.2s;
// //                                         }

// //                                         .dropdown-item:hover {
// //                                           background: #f1f1f1;
// //                                         }
// //                                       `}
// //                                     </style>

// //                                     {/* BUTTON INPUT BOXES */}
// //                                     {templateHeadersList.buttonvariables.map(
// //                                       (variable, index) => (
// //                                         <div className="mb-3" key={index}>
// //                                           <label
// //                                             htmlFor={`templateVariable-${index}`}
// //                                             className="form-label"
// //                                           >
// //                                             {`BUTTON VARIABLE #${index + 1}`}
// //                                           </label>
// //                                           <input
// //                                             type="text"
// //                                             id={`templateVariable-${index}`}
// //                                             className="form-control"
// //                                             value={
// //                                               templateButtonVariables[index] ||
// //                                               ""
// //                                             }
// //                                             placeholder={`Enter value for ${variable}`}
// //                                             onChange={(e) =>
// //                                               handleButtonVariableChange(
// //                                                 index,
// //                                                 e.target.value
// //                                               )
// //                                             }
// //                                           />
// //                                         </div>
// //                                       )
// //                                     )}
// //                                   </div>

// //                                   <div
// //                                     className="template_preview"
// //                                     style={{ maxWidth: "60%" }}
// //                                   >
// //                                     <label
// //                                       htmlFor="templateBodyVariable1"
// //                                       className="form-label"
// //                                     >
// //                                       Template View :
// //                                     </label>
// //                                     <div className="whatsapp-modal-content">
// //                                       <div className="border p-2">
// //                                         <div className="message_template">
// //                                           {templateHeadersList.headerText && (
// //                                             <div className="header-text fw-bold">
// //                                               {getUpdatedHeaderText()}
// //                                             </div>
// //                                           )}

// //                                           {templateHeadersList.templateText && (
// //                                             <div
// //                                               className="whatsapp-message"
// //                                               dangerouslySetInnerHTML={{
// //                                                 __html:
// //                                                   getUpdatedTemplateText().replace(
// //                                                     /\n/g,
// //                                                     "<br>"
// //                                                   ),
// //                                               }}
// //                                             />
// //                                           )}
// //                                         </div>
// //                                         {templateHeadersList.buttons &&
// //                                           templateHeadersList.buttons.length >
// //                                             0 && (
// //                                             <div
// //                                               className={`d-flex gap-3 mt-2 mb-3 ${
// //                                                 templateHeadersList.buttons
// //                                                   .length > 2
// //                                                   ? "flex-wrap"
// //                                                   : ""
// //                                               }`}
// //                                             >
// //                                               {templateHeadersList.buttons.map(
// //                                                 (button, index) => (
// //                                                   <a
// //                                                     key={index}
// //                                                     href={button.url}
// //                                                     className="btn btn-success d-block mt-2 small_button"
// //                                                     target="_blank"
// //                                                     rel="noopener noreferrer"
// //                                                     style={{
// //                                                       flex:
// //                                                         templateHeadersList
// //                                                           .buttons.length > 2
// //                                                           ? "1 1 calc(50% - 1.5rem)"
// //                                                           : "unset",
// //                                                     }}
// //                                                   >
// //                                                     {button.text}
// //                                                   </a>
// //                                                 )
// //                                               )}
// //                                             </div>
// //                                           )}
// //                                       </div>
// //                                     </div>
// //                                   </div>
// //                                 </div>
// //                               )}
// //                           </div>
// //                         </div>
// //                       </div>
// //                     </div>
// //                     <div className="text-end p-3">
// //                       <button type="submit" className="btn btn-primary">
// //                         Update
// //                       </button>
// //                     </div>
// //                   </div>
// //                 </form>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default CampaignScheduleEditForm;

// // =======================================FULL EDIT FORM======================================================
// import React, { useEffect, useState, useRef, useMemo } from "react";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import Select, { components } from "react-select";
// import { toast } from "react-toastify";

// const CampaignScheduleEditForm = () => {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const inputRefs = useRef([]);
//   const [loading, setLoading] = useState(true);

//   // States
//   const [campaignDetails, setCampaignDetails] = useState("");
//   const [campaignName, setCampaignName] = useState("");
//   const [campaignType, setCampaignType] = useState("");
//   const [scheduleDate, setScheduleDate] = useState("");
//   const [audience, setAudience] = useState("");
//   const [audienceCount, setAudienceCount] = useState(0);
//   const [startDate, setStartDate] = useState(
//     new Date().toISOString().split("T")[0]
//   );

//   const [endDate, setEndDate] = useState(startDate);
//   const [campaignBatchId, setCampaignBatchId] = useState("");
//   const [batchIds, setBatchIds] = useState([]);
//   const [channelSelected, setChannelSelected] = useState(false);
//   const [selectedChannelId, setSelectedChannelId] = useState("");
//   const [selectedChannelConnectionName, setSelectedChannelConnectionName] =
//     useState("");
//   const [messageType, setMessageType] = useState("");

//   const [selectedTemplateId, setSelectedTemplateId] = useState("");

//   const [templateVariables, setTemplateVariables] = useState({});
//   const [templateButtonVariables, setTemplateButtonVariables] = useState({});
//   const [templateHeadersList, setTemplateHeadersList] = useState({
//     inputvariables: [],
//     buttonvariables: [],
//   });
//   const [templateHeaderVariables, setTemplateHeaderVariables] = useState("");
//   const [templateHeaderImage, setTemplateHeaderImage] = useState("");
//   const [templateHeaderVideo, setTemplateHeaderVideo] = useState("");
//   const [templateHeaderDocument, setTemplateHeaderDocument] = useState("");
//   const [templateMessage, setTemplateMessage] = useState("");
//   const [templateList, setTemplateList] = useState([]);
//   const [channelList, setChannelList] = useState([]);
//   const [dropdownOpen, setDropdownOpen] = useState(null);

//   const [batchData, setBatchData] = useState([]);

//   const predefinedOptions = ["{{name}}", "{{email}}", "{{phone}}"];
//   const [predefinedTemplates, setPredefinedTemplates] = useState([]);

//   useEffect(() => {
//     const fetchPredefinedTemplates = async () => {
//       try {
//         const response = await axios.get("/api/predefinedtemplate/getall");
//         console.log(response);
//         setPredefinedTemplates(response.data.data);
//       } catch (error) {
//         console.error("Failed to fetch predefined templates:", error);
//       }
//     };

//     fetchPredefinedTemplates();
//   }, []);

//   const fetchBatchDetails = async (campaignId) => {
//     try {
//       const response = await axios.get(
//         `/api/campaignscheduler/getcampaign/${campaignId}`
//       );
//       if (response.status === 200) {
//         setAudienceCount(response.data.length);
//         setBatchData(response.data);
//       } else {
//         console.error("Failed to fetch Audience");
//       }
//     } catch (error) {
//       console.error("Error fetching batch details:", error);
//     }
//   };

//   useEffect(() => {
//     const fetchCampaignData = async () => {
//       try {
//         const response = await axios.get(
//           `/api/campaignscheduler/get_campaign_scheduler/${id}`
//         );
//         const data = response.data;
//         console.log(data);

//         setCampaignDetails(data.campaignDetails || "");
//         setCampaignName(data.campaignName || "");
//         setCampaignType(data.campaignType || "");
//         setScheduleDate(data.scheduleDate || "");
//         setAudience(data.audience || "");
//         setStartDate(data.startDate || new Date().toISOString().split("T")[0]);
//         setCampaignBatchId(data.campaignBatchId || "");
//         setChannelSelected(data.channelSelected || false);
//         setSelectedChannelId(data.selectedChannelId || "");
//         setSelectedChannelConnectionName(
//           data.selectedChannelConnectionName || ""
//         );
//         setMessageType(data.messageType || "");
//         setTemplateVariables(data.templateVariables || {});
//         setTemplateButtonVariables(data.templateButtonVariables || {});
//         // setTemplateMessage(data.templateHeadersList.data.name || "");
//         setTemplateMessage(data.templateHeadersList.data.id || "");
//         setTemplateHeadersList(
//           data.templateHeadersList || {
//             inputvariables: [],
//             buttonvariables: [],
//           }
//         );
//         setTemplateHeaderVariables(data.updatedHeaderText || "");
//         setTemplateHeaderImage(data.updatedHeaderImage || "");
//         setTemplateHeaderVideo(data.updatedHeaderVideo || "");
//         setTemplateHeaderDocument(data.updatedHeaderDocument || "");

//         // ✅ Pass preselected batch ID to avoid overwriting
//         await fetchBatchIds(data.startDate, data.campaignBatchId);
//       } catch (error) {
//         toast.error("Unable to load campaign data for duplication");
//       }
//     };

//     fetchCampaignData();
//   }, [id]);

//   console.log(messageType);
//   console.log(templateMessage);

//   const fetchBatchIds = async (date, preselectedBatchId = "") => {
//     try {
//       const isoDate = new Date(date).toISOString().split("T")[0];
//       const response = await axios.get(
//         `/api/campaignscheduler/getfiltercampaign`,
//         {
//           params: { startDate: isoDate, endDate: date },
//         }
//       );

//       if (response.status === 200) {
//         const batchList = response.data.contact;
//         setBatchIds(batchList);

//         // ✅ Only set default if there's no preselected value
//         if (!preselectedBatchId) {
//           const firstBatchId =
//             batchList.length > 0 && batchList[0] !== "No campaigns available"
//               ? batchList[0]
//               : "";
//           setCampaignBatchId(firstBatchId);

//           if (firstBatchId) {
//             fetchBatchDetails(firstBatchId);
//           }
//         } else {
//           // If we already have a preselected one, just fetch its details
//           fetchBatchDetails(preselectedBatchId);
//         }
//       } else {
//         console.error("Failed to fetch batch IDs:", response.data.message);
//       }
//     } catch (error) {
//       console.error("Error fetching batch IDs:", error);
//     }
//   };

//   const fetchChannelData = async () => {
//     try {
//       const response = await axios.get("/api/campaignscheduler/getallchannel");
//       setChannelList(response.data);
//       // console.log("Channel List :", response.data);
//     } catch (error) {
//       console.error("Failed to fetch channels:", error);
//     }
//   };

//   const fetchChannelListData = async () => {
//     try {
//       const response = await axios.get(
//         "/api/campaignscheduler/getallchannellist"
//       );
//       setChannelList(response.data);
//       // console.log("Channel List :", response.data);
//     } catch (error) {
//       console.error("Failed to fetch channels:", error);
//     }
//   };

//   useEffect(() => {
//     if (campaignDetails === "WA Cloud") {
//       fetchChannelData();
//     } else if (campaignDetails === "WA Team") {
//       fetchChannelListData();
//     }
//   }, [campaignDetails]);

//   const [visibleOptions, setVisibleOptions] = useState(7);

//   // const options = templateList.map((template) => ({
//   //   value: template.id,
//   //   label: `${template.name} - 🟢${template.status} - 🟠${template.category}`,
//   // }));

//   const options = useMemo(() => {
//     return templateList.map((template) => ({
//       value: template.id,
//       label: `${template.name} - 🟢${template.status} - 🟠${template.category}`,
//     }));
//   }, [templateList]);

//   const MenuList = (props) => {
//     const { children } = props;

//     // Normal options + See More button
//     return (
//       <components.MenuList {...props}>
//         {children}
//         {options.length > visibleOptions && (
//           <div
//             style={{
//               padding: "8px",
//               textAlign: "center",
//               cursor: "pointer",
//               color: "blue",
//               fontWeight: "500",
//             }}
//             onClick={(e) => {
//               e.stopPropagation(); // prevent selecting
//               setVisibleOptions((prev) => prev + 7);
//             }}
//           >
//             See More
//           </div>
//         )}
//       </components.MenuList>
//     );
//   };

//   const fetchTemplateList = async () => {
//     if (!selectedChannelId || templateList.length > 0) return;

//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `/api/campaignscheduler/${selectedChannelId}/getalltemplateapproved`
//       );
//       setTemplateList(response.data);
//       console.log("Template List :", response.data);
//     } catch (error) {
//       console.error("Failed to fetch templates:", error);
//       alert("Failed to fetch templates Cloud. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchTemplateListVersionTwo = async () => {
//     if (!selectedChannelId) return;

//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `/api/campaignscheduler/${selectedChannelId}/getalltemplateapprovedversiontwo`
//       );
//       // setTemplateList(response.data);
//       // ✅ FIX HERE
//       const templates = Array.isArray(response.data)
//         ? response.data
//         : response.data.data || [];

//       setTemplateList(templates);
//       console.log("Template List Version Two :", response.data);
//     } catch (error) {
//       console.error("Failed to fetch templates:", error);
//       toast.error("Failed to fetch templates V2. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (selectedChannelId) {
//       if (campaignDetails === "WA Cloud") {
//         fetchTemplateList();
//       } else if (campaignDetails === "WA Team") {
//         fetchTemplateListVersionTwo();
//       }
//     }
//   }, [selectedChannelId]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const formData = {
//       campaignDetails,
//       campaignName,
//       campaignType,
//       scheduleDate: campaignType === "Immediate" ? "" : scheduleDate,
//       audience,
//       startDate,
//       campaignBatchId,
//       channelSelected,
//       selectedChannelId,
//       selectedChannelConnectionName,
//       messageType,
//       templateVariables,
//       templateButtonVariables,
//       templateMessage,
//       templateHeadersList,
//       templateHeaderVariables,
//       templateHeaderImage,
//       templateHeaderVideo,
//       updatedTemplateText: updatedTemplateText,
//       updatedTemplateButton: updatedTemplateButton,
//       updatedHeaderText: updatedHeaderText,
//       updatedHeaderImage: updatedHeaderImage,
//       updatedHeaderVideo: updatedHeaderVideo,
//       updatedHeaderDocument: updatedHeaderDocument,
//       templateHeaderDocument,
//     };

//     console.log(formData);

//     try {
//       const response = await axios.put(
//         `/api/campaignscheduler/update_campaign_scheduler/${id}`,
//         formData
//       );
//       if (response.status === 201 || response.status === 200) {
//         toast.success("Campaign updated successfully!");
//         navigate(-1);
//       }
//     } catch (error) {
//       toast.error("Failed to update campaign. Try again!");
//     }
//   };

//   // Handlers for form fields
//   const handleCampaignDetailsChange = (e) => setCampaignDetails(e.target.value);
//   const handleCampaignNameChange = (e) => setCampaignName(e.target.value);
//   const handleCampaignTypeChange = (e) => setCampaignType(e.target.value);
//   const handleScheduleDateChange = (e) => setScheduleDate(e.target.value);
//   const handleAudienceChange = (e) => setAudience(e.target.value);
//   // const handleDateChange = (e) => setStartDate(e.target.value);

//   const handleDateChange = async (e) => {
//     const date = e.target.value;
//     setStartDate(date);
//     setEndDate(date);

//     if (date) {
//       fetchBatchIds(date);
//     }
//   };

//   const handleBatchChange = async (event) => {
//     const campaignId = event.target.value;
//     setCampaignBatchId(campaignId);

//     if (campaignId) {
//       fetchBatchDetails(campaignId);
//     }
//   };

//   const handleChannelChange = (e) => {
//     const channelData = JSON.parse(e.target.value);
//     setSelectedChannelId(channelData.id);
//     setSelectedChannelConnectionName(channelData.name);
//     setChannelSelected(true);
//   };
//   const handleMessageTypeChange = (e) => setMessageType(e.target.value);
//   // const handleTemplateHeadersChange = (e) => setTemplateMessage(e.target.value);

//   const handleTemplateHeadersChange = (event) => {
//     const templateId = event.target.value;
//     setSelectedTemplateId(templateId);
//   };

//   const handlePredefinedTemplateSelect = (templateId) => {
//     const selectedTemplate = predefinedTemplates.find(
//       (template) => template._id === templateId
//     );

//     if (selectedTemplate) {
//       const values = selectedTemplate.predefinedtemplate || [];

//       const headerVarCount = templateHeadersList.headervariables.length || 0;
//       const bodyVarCount = templateHeadersList.inputvariables.length || 0;
//       const buttonVarCount = templateHeadersList.buttonvariables?.length || 0;

//       const headerVars = {};
//       const bodyVars = {};
//       const buttonVars = {};

//       let index = 0;

//       // Fill HEADER VARIABLES first
//       for (let i = 0; i < headerVarCount; i++) {
//         headerVars[i] = values[index] || "";
//         index++;
//       }

//       // Fill BODY VARIABLES next
//       for (let i = 0; i < bodyVarCount; i++) {
//         bodyVars[i] = values[index] || "";
//         index++;
//       }

//       // Fill BUTTON VARIABLES last
//       for (let i = 0; i < buttonVarCount; i++) {
//         buttonVars[i] = values[index] || "";
//         index++;
//       }

//       setTemplateHeaderVariables(headerVars);
//       setTemplateVariables(bodyVars);
//       setTemplateButtonVariables(buttonVars);
//     }
//   };

//   // const handleHeaderVariableChange = (index, value) => {
//   //   setTemplateHeaderVariables((prev) => ({ ...prev, [index]: value }));
//   // };

//   const handleHeaderVariableChange = (value) => {
//     setTemplateHeaderVariables(value);
//   };
//   const handleHeaderImageChange = (e) => setTemplateHeaderImage(e.target.value);
//   const handleHeaderVideoChange = (e) => setTemplateHeaderVideo(e.target.value);

//   const handleHeaderDocumentChange = (e) =>
//     setTemplateHeaderDocument(e.target.value);

//   const handleInsertVariableChange = (index, value) => {
//     setTemplateVariables((prev) => ({ ...prev, [index]: value }));
//   };

//   const handleInsertText = (index, value) => {
//     setTemplateVariables((prev) => ({
//       ...prev,
//       [index]: (prev[index] || "") + value,
//     }));
//     setDropdownOpen(null);
//   };

//   const handleButtonVariableChange = (index, value) => {
//     setTemplateButtonVariables((prev) => ({ ...prev, [index]: value }));
//   };

//   const getUpdatedTemplateText = () => {
//     // Replace placeholders in templateText with corresponding values from templateVariables
//     let updatedText = templateHeadersList.templateText;
//     templateHeadersList.inputvariables.forEach((variable, index) => {
//       const placeholder = new RegExp(`\\{\\{${index + 1}\\}\\}`, "g"); // Match {{1}}, {{2}}, etc.
//       updatedText = updatedText.replace(
//         placeholder,
//         templateVariables[index] || variable
//       ); // Replace with input value or leave placeholder
//     });
//     // console.log("UpdatedText", updatedText);
//     return updatedText;
//   };

//   const getUpdatedTemplateButton = () => {
//     if (!templateHeadersList || !Array.isArray(templateHeadersList.buttons)) {
//       console.error(
//         "Error: templateHeadersList.buttons is undefined or not an array."
//       );
//       return [];
//     }

//     let updatedButtons = templateHeadersList.buttons.map(
//       (button, buttonIndex) => {
//         let updatedButton = { ...button };

//         if (
//           updatedButton.url &&
//           Array.isArray(templateHeadersList.buttonvariables)
//         ) {
//           // Each button gets its index-mapped value from templateButtonVariables
//           const variable = templateHeadersList.buttonvariables[buttonIndex]; // Get the corresponding placeholder
//           if (variable) {
//             const replacementValue = templateButtonVariables[buttonIndex] ?? ""; // Map to templateButtonVariables index

//             updatedButton.url = updatedButton.url.replace(
//               variable,
//               replacementValue
//             );
//           }
//         }

//         return updatedButton;
//       }
//     );

//     return updatedButtons;
//   };

//   const getUpdatedHeaderText = () => {
//     let updatedHeaderText = templateHeadersList?.headerText || "";

//     if (Array.isArray(templateHeadersList?.headervariables)) {
//       templateHeadersList.headervariables.forEach((variable, index) => {
//         const placeholder = new RegExp(`\\{\\{${index + 1}\\}\\}`, "g");
//         updatedHeaderText = updatedHeaderText.replace(
//           placeholder,
//           templateHeaderVariables || variable
//         );
//       });
//     }

//     return updatedHeaderText;
//   };

//   const getUpdatedHeaderImage = () => {
//     // console.log("Template Header List", templateHeadersList.headerImageUrl);
//     let updatedHeaderImage = templateHeadersList.headerImageUrl;

//     // Directly replace headerImageUrl with user input from templateHeaderImage
//     if (templateHeaderImage) {
//       updatedHeaderImage = templateHeaderImage;
//     }

//     // console.log("updatedHeaderImage", updatedHeaderImage);
//     return updatedHeaderImage;
//   };

//   const getUpdatedHeaderVideo = () => {
//     // console.log("Template Header List", templateHeadersList.headerVideoUrl);
//     let updatedHeaderVideo = templateHeadersList.headerVideoUrl;

//     // Directly replace headerImageUrl with user input from templateHeaderVideo
//     if (templateHeaderVideo) {
//       updatedHeaderVideo = templateHeaderVideo;
//     }

//     // console.log("updatedHeaderImage", updatedHeaderVideo);
//     return updatedHeaderVideo;
//   };

//   const getUpdatedHeaderDocument = () => {
//     // console.log("Template Header List", templateHeadersList.headerPdfUrl);
//     let updatedHeaderDocument = templateHeadersList.headerPdfUrl;

//     // Directly replace headerImageUrl with user input from templateHeaderDocument
//     if (templateHeaderDocument) {
//       updatedHeaderDocument = templateHeaderDocument;
//     }

//     // console.log("updatedHeaderDocument", updatedHeaderDocument);
//     return updatedHeaderDocument;
//   };

//   const updatedTemplateText = getUpdatedTemplateText();
//   const updatedTemplateButton = getUpdatedTemplateButton();
//   const updatedHeaderText = getUpdatedHeaderText();
//   const updatedHeaderImage = getUpdatedHeaderImage();
//   const updatedHeaderVideo = getUpdatedHeaderVideo();
//   const updatedHeaderDocument = getUpdatedHeaderDocument();

//   useEffect(() => {
//     if (templateList.length > 0 && templateMessage) {
//       handleTemplateHeadersChange({ target: { value: templateMessage } });
//     }
//   }, [templateList, templateMessage]);

//   useEffect(() => {
//     const fetchTemplateHeaders = async () => {
//       if (!selectedTemplateId || !selectedChannelId) return; // Only fetch if both are selected
//       console.log(selectedTemplateId);
//       try {
//         const response = await axios.get(
//           `/api/campaignscheduler/${selectedChannelId}/gettemplate/${selectedTemplateId}`
//         );
//         setTemplateHeadersList(response.data || []);
//       } catch (error) {
//         console.error("Failed to fetch template headers:", error);
//       }
//     };

//     fetchTemplateHeaders();
//   }, [selectedChannelId, selectedTemplateId]);

//   return (
//     <div className="page-content w-100">
//       <div className="container mt-5">
//         <div className="row">
//           <div className="col-12 d-flex justify-content-between align-items-center">
//             <h4>Campaign Scheduler Edit Form</h4>
//             <button
//               className="btn btn-secondary btn-sm"
//               onClick={() => navigate(-1)}
//             >
//               &larr; Back
//             </button>
//           </div>
//         </div>

//         <div className="row mt-4">
//           <div className="col-lg-12">
//             <div className="card shadow-sm">
//               <div className="card-body">
//                 <form onSubmit={handleSubmit}>
//                   <div className="d-flex gap-3 flex-column">
//                     <div
//                       className="d-flex gap-2"
//                       style={{
//                         padding: "10px 15px",
//                       }}
//                     >
//                       {/* Campaign Details */}
//                       <div
//                         className="mx-auto"
//                         style={{
//                           padding: "10px 15px",
//                           width: "33.33%",
//                         }}
//                       >
//                         <div className="mb-2">
//                           <label className="form-label fw-bold">
//                             Campaign Details:
//                           </label>
//                           <div className="d-flex gap-3 mt-2">
//                             <div className="form-check">
//                               <input
//                                 className="form-check-input"
//                                 type="radio"
//                                 name="campaignDetailsOptions"
//                                 id="campaignDetails1"
//                                 value="WA Cloud"
//                                 checked={campaignDetails === "WA Cloud"}
//                                 onChange={handleCampaignDetailsChange}
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor="campaignDetails1"
//                               >
//                                 WA Cloud
//                               </label>
//                             </div>
//                             <div className="form-check">
//                               <input
//                                 className="form-check-input"
//                                 type="radio"
//                                 name="campaignDetailsOptions"
//                                 id="campaignDetails2"
//                                 value="WA Team"
//                                 checked={campaignDetails === "WA Team"}
//                                 onChange={handleCampaignDetailsChange}
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor="campaignDetails2"
//                               >
//                                 WA Team
//                               </label>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       {/* Campaing Name */}
//                       <div
//                         className="mx-auto"
//                         style={{
//                           padding: "10px 15px",
//                           width: "33.33%",
//                         }}
//                       >
//                         <div className="mb-2">
//                           <label
//                             className="form-label fw-bold"
//                             htmlFor="campaignName"
//                           >
//                             Campaign Name:
//                           </label>
//                           <input
//                             type="text"
//                             id="campaignName"
//                             className="form-control"
//                             placeholder="Enter Campaign Name"
//                             value={campaignName}
//                             onChange={handleCampaignNameChange}
//                           />
//                         </div>
//                       </div>
//                       {/* Campaign Type */}
//                       <div
//                         className="mx-auto"
//                         style={{
//                           padding: "10px 15px",
//                           width: "33.33%",
//                         }}
//                       >
//                         <div className="mb-2">
//                           <label className="form-label fw-bold">
//                             Campaign Type:
//                           </label>
//                           <div>
//                             <div className="d-flex gap-3 mt-2">
//                               <div className="form-check">
//                                 <input
//                                   className="form-check-input"
//                                   type="radio"
//                                   name="campaignTypeOptions"
//                                   id="campaignType1"
//                                   value="Immediate"
//                                   checked={campaignType === "Immediate"}
//                                   onChange={handleCampaignTypeChange}
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor="campaignType1"
//                                 >
//                                   Immediate
//                                 </label>
//                               </div>
//                               <div className="form-check">
//                                 <input
//                                   className="form-check-input"
//                                   type="radio"
//                                   name="campaignTypeOptions"
//                                   id="campaignType2"
//                                   value="Schedule"
//                                   checked={campaignType === "Schedule"}
//                                   onChange={handleCampaignTypeChange}
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor="campaignType2"
//                                 >
//                                   Schedule
//                                 </label>
//                               </div>
//                             </div>

//                             {campaignType === "Schedule" && (
//                               <div className="mt-2">
//                                 <label
//                                   htmlFor="dateTimeSelect"
//                                   className="form-label"
//                                 >
//                                   Schedule Date & Time:
//                                 </label>
//                                 <input
//                                   type="datetime-local"
//                                   className="form-control"
//                                   id="dateTimeSelect"
//                                   // value={scheduleDate}
//                                   value={new Date(scheduleDate)
//                                     .toLocaleString("sv-SE", {
//                                       timeZone: "Asia/Kolkata",
//                                     })
//                                     .replace(" ", "T")}
//                                   onChange={handleScheduleDateChange}
//                                 />
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div
//                       className="d-flex gap-2"
//                       style={{
//                         padding: "10px 15px",
//                       }}
//                     >
//                       <div
//                         className="mx-auto"
//                         style={{
//                           width: "40%",
//                           padding: "10px 15px",
//                         }}
//                       >
//                         <div className="mb-2">
//                           <div>
//                             <label className="form-label fw-bold">
//                               Audience: {audienceCount}
//                             </label>
//                           </div>
//                           <div>
//                             <div className="d-flex gap-3 mt-1">
//                               <div className="form-check">
//                                 <input
//                                   className="form-check-input"
//                                   type="radio"
//                                   name="AudienceOptions"
//                                   id="Audience1"
//                                   value="All Contacts"
//                                   checked={audience === "All Contacts"}
//                                   onChange={handleAudienceChange}
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor="Audience1"
//                                 >
//                                   All Contacts from CRM
//                                 </label>
//                               </div>
//                               <div className="form-check">
//                                 <input
//                                   className="form-check-input"
//                                   type="radio"
//                                   name="AudienceOptions"
//                                   id="Audience2"
//                                   value="Segmented"
//                                   checked={audience === "Segmented"}
//                                   onChange={handleAudienceChange}
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor="Audience2"
//                                 >
//                                   Segmented
//                                 </label>
//                               </div>
//                             </div>

//                             {audience === "Segmented" && (
//                               <div className="d-flex gap-3 mt-3">
//                                 <div className="mt-3">
//                                   <label
//                                     htmlFor="dateSelect"
//                                     className="form-label"
//                                   >
//                                     Campaign Date:
//                                   </label>
//                                   <input
//                                     type="date"
//                                     className="form-control"
//                                     id="dateSelect"
//                                     // value={startDate}

//                                     value={new Date(
//                                       startDate
//                                     ).toLocaleDateString("sv-SE", {
//                                       timeZone: "Asia/Kolkata",
//                                     })}
//                                     onChange={handleDateChange}
//                                   />
//                                 </div>

//                                 <div className="mt-3">
//                                   <label
//                                     htmlFor="batchSelect"
//                                     className="form-label"
//                                   >
//                                     Campaign Batch ID:
//                                   </label>

//                                   <select
//                                     id="batchSelect"
//                                     className="form-select"
//                                     value={campaignBatchId || ""}
//                                     onChange={handleBatchChange}
//                                     disabled={!batchIds.length}
//                                   >
//                                     {batchIds.length ? (
//                                       <>
//                                         <option value="" disabled>
//                                           Select an option
//                                         </option>
//                                         {batchIds.map((id) => (
//                                           <option key={id} value={id}>
//                                             {id}
//                                           </option>
//                                         ))}
//                                       </>
//                                     ) : (
//                                       <option value="" disabled>
//                                         No batch IDs found
//                                       </option>
//                                     )}
//                                   </select>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                       <div
//                         className="mx-auto"
//                         style={{
//                           width: "60%",
//                           padding: "10px 15px",
//                         }}
//                       >
//                         <div className="mb-2">
//                           <div>
//                             <label className="form-label fw-bold">
//                               Template:
//                             </label>
//                           </div>
//                           <div>
//                             <div className="d-flex gap-5 align-items-center">
//                               <label
//                                 htmlFor="channelSelect"
//                                 className="form-label"
//                               >
//                                 Channel:
//                               </label>
//                               <select
//                                 id="channelSelect"
//                                 className="form-select"
//                                 aria-label="Select a channel"
//                                 onChange={handleChannelChange}
//                                 // disabled={campaignDetails !== "WA Cloud"}
//                                 disabled={
//                                   !(
//                                     campaignDetails === "WA Cloud" ||
//                                     campaignDetails === "WA Team"
//                                   )
//                                 }
//                                 value={
//                                   selectedChannelId
//                                     ? JSON.stringify({
//                                         id: selectedChannelId,
//                                         name: selectedChannelConnectionName,
//                                       })
//                                     : ""
//                                 }
//                               >
//                                 <option value="" disabled selected>
//                                   Select an option
//                                 </option>
//                                 {channelList.map((channel) => (
//                                   <option
//                                     key={channel._id}
//                                     value={JSON.stringify({
//                                       id: channel._id,
//                                       name: channel.connectionname,
//                                     })}
//                                   >
//                                     {channel.connectionname}
//                                   </option>
//                                 ))}
//                               </select>
//                             </div>

//                             {channelSelected && (
//                               <div className="mt-3">
//                                 <label
//                                   htmlFor="channelSelect"
//                                   className="form-label"
//                                 >
//                                   Message Type:
//                                 </label>
//                                 <div className="d-flex gap-5 mt-2">
//                                   <div className="form-check">
//                                     <input
//                                       className="form-check-input"
//                                       type="radio"
//                                       name="TemplateOptions"
//                                       id="template1"
//                                       value="Pre-Approved"
//                                       checked={messageType === "Pre-Approved"}
//                                       onChange={handleMessageTypeChange}
//                                     />
//                                     <label
//                                       className="form-check-label"
//                                       htmlFor="template1"
//                                     >
//                                       Pre-Approved Template
//                                     </label>
//                                   </div>
//                                   <div className="form-check">
//                                     <input
//                                       className="form-check-input"
//                                       type="radio"
//                                       name="TemplateOptions"
//                                       id="template2"
//                                       value="Regular Message"
//                                       checked={
//                                         messageType === "Regular Message"
//                                       }
//                                       onChange={handleMessageTypeChange}
//                                     />
//                                     <label
//                                       className="form-check-label"
//                                       htmlFor="template2"
//                                     >
//                                       Regular Message
//                                     </label>
//                                   </div>
//                                 </div>
//                               </div>
//                             )}

//                             {messageType === "Pre-Approved" && (
//                               <div className="mt-3">
//                                 <label
//                                   htmlFor="templateSelect"
//                                   className="form-label"
//                                 >
//                                   Template:
//                                 </label>
//                                 <Select
//                                   inputId="templateSelect"
//                                   // options={options}
//                                   options={options.slice(0, visibleOptions)}
//                                   components={{ MenuList }}
//                                   // onChange={(selectedOption) =>
//                                   //   handleTemplateHeadersChange({
//                                   //     target: { value: selectedOption.value },
//                                   //   })
//                                   // }
//                                   onChange={(selectedOption) => {
//                                     // state update karo
//                                     setTemplateMessage(selectedOption.value);

//                                     // Reset niche ka form
//                                     setTemplateHeaderVariables([]);
//                                     setTemplateHeaderImage(null);
//                                     setTemplateHeaderVideo(null);
//                                     setTemplateHeaderDocument(null);
//                                     setTemplateVariables([]);
//                                     setTemplateButtonVariables([]);

//                                     // agar aapko pehle se defined function bhi chalana hai
//                                     handleTemplateHeadersChange({
//                                       target: { value: selectedOption.value },
//                                     });
//                                   }}
//                                   value={
//                                     options.find(
//                                       (opt) => opt.value === templateMessage
//                                     ) || null
//                                   }
//                                   placeholder="Select a template..."
//                                   isSearchable
//                                   isLoading={templateList.length === 0}
//                                 />
//                               </div>
//                             )}

//                             {/* Dynamic Input Boxes */}
//                             {templateHeadersList.inputvariables &&
//                               templateHeadersList.inputvariables.length > 0 && (
//                                 <div className="d-flex gap-3 mt-4">
//                                   <div
//                                     className="input_variables"
//                                     style={{
//                                       maxWidth: "40%",
//                                     }}
//                                   >
//                                     {/* PREDEFINED TEMPLATES SELECT */}
//                                     <select
//                                       className="form-select mb-3"
//                                       onChange={(e) =>
//                                         handlePredefinedTemplateSelect(
//                                           e.target.value
//                                         )
//                                       }
//                                     >
//                                       <option value="" disabled selected>
//                                         Select pre-template
//                                       </option>
//                                       {predefinedTemplates.map((template) => (
//                                         <option
//                                           key={template._id}
//                                           value={template._id}
//                                         >
//                                           {template.templatename}
//                                         </option>
//                                       ))}
//                                     </select>

//                                     {/* HEADER INPUTS BASED ON headerFormat */}
//                                     {templateHeadersList.headerFormat ===
//                                       "TEXT" &&
//                                       templateHeadersList.headervariables.map(
//                                         (variable, index) => (
//                                           <div className="mb-3" key={index}>
//                                             <label
//                                               htmlFor={`templateVariable-${index}`}
//                                               className="form-label"
//                                             >
//                                               {`HEADER VARIABLE #${index + 1}`}
//                                             </label>
//                                             <input
//                                               type="text"
//                                               id={`templateVariable-${index}`}
//                                               className="form-control"
//                                               placeholder={`Enter value for ${variable}`}
//                                               value={
//                                                 templateHeaderVariables || ""
//                                               }
//                                               onChange={(e) =>
//                                                 handleHeaderVariableChange(
//                                                   e.target.value
//                                                 )
//                                               }
//                                             />
//                                           </div>
//                                         )
//                                       )}

//                                     {templateHeadersList.headerFormat ===
//                                       "IMAGE" && (
//                                       <div className="mb-3">
//                                         <label
//                                           htmlFor="headerImageUpload"
//                                           className="form-label"
//                                         >
//                                           HEADER IMAGE:
//                                         </label>
//                                         <input
//                                           type="text"
//                                           id="headerImageUpload"
//                                           className="form-control"
//                                           placeholder="Enter image URL"
//                                           value={templateHeaderImage || ""}
//                                           onChange={handleHeaderImageChange}
//                                         />
//                                       </div>
//                                     )}

//                                     {templateHeadersList.headerFormat ===
//                                       "VIDEO" && (
//                                       <div className="mb-3">
//                                         <label
//                                           htmlFor="headerVideoUpload"
//                                           className="form-label"
//                                         >
//                                           HEADER VIDEO:
//                                         </label>
//                                         <input
//                                           type="text"
//                                           id="headerVideoUpload"
//                                           className="form-control"
//                                           placeholder="Enter video URL"
//                                           value={templateHeaderVideo || ""}
//                                           onChange={handleHeaderVideoChange}
//                                         />
//                                       </div>
//                                     )}

//                                     {templateHeadersList.headerFormat ===
//                                       "DOCUMENT" && (
//                                       <div className="mb-3">
//                                         <label
//                                           htmlFor="headerDocumentUpload"
//                                           className="form-label"
//                                         >
//                                           HEADER DOCUMENT:
//                                         </label>
//                                         <input
//                                           type="text"
//                                           id="headerDocumentUpload"
//                                           className="form-control"
//                                           placeholder="Enter document URL"
//                                           value={templateHeaderDocument || ""}
//                                           onChange={handleHeaderDocumentChange}
//                                         />
//                                       </div>
//                                     )}

//                                     {/* BODY INPUT BOXES */}

//                                     {templateHeadersList.inputvariables.map(
//                                       (variable, index) => (
//                                         <div
//                                           className="mb-3 position-relative"
//                                           key={index}
//                                         >
//                                           <label className="form-label">{`BODY VARIABLE #${
//                                             index + 1
//                                           }`}</label>
//                                           <div className="input-container">
//                                             {/* Input Field */}
//                                             <input
//                                               type="text"
//                                               ref={(el) =>
//                                                 (inputRefs.current[index] = el)
//                                               }
//                                               className="form-control custom-input"
//                                               placeholder={`Enter value for ${variable}`}
//                                               value={
//                                                 templateVariables[index] || ""
//                                               }
//                                               onChange={(e) =>
//                                                 handleInsertVariableChange(
//                                                   index,
//                                                   e.target.value
//                                                 )
//                                               }
//                                             />

//                                             {/* Dropdown Icon Inside Input Field */}
//                                             <span
//                                               className="custom-dropdown-icon"
//                                               onClick={() =>
//                                                 setDropdownOpen(
//                                                   dropdownOpen === index
//                                                     ? null
//                                                     : index
//                                                 )
//                                               }
//                                             >
//                                               &lt;&gt;
//                                             </span>

//                                             {/* Dropdown Inside Input Field */}
//                                             {dropdownOpen === index && (
//                                               <div className="custom-dropdown">
//                                                 {predefinedOptions.map(
//                                                   (option, idx) => (
//                                                     <div
//                                                       key={idx}
//                                                       className="dropdown-item"
//                                                       onClick={() =>
//                                                         handleInsertText(
//                                                           index,
//                                                           option
//                                                         )
//                                                       }
//                                                     >
//                                                       {option}
//                                                     </div>
//                                                   )
//                                                 )}
//                                               </div>
//                                             )}
//                                           </div>
//                                         </div>
//                                       )
//                                     )}

//                                     <style>
//                                       {`
//                                         .input-container {
//                                           position: relative;
//                                           display: flex;
//                                           align-items: center;
//                                         }

//                                         .custom-input {
//                                           width: 100%;
//                                           padding-right: 35px; /* Space for the dropdown icon */
//                                         }

//                                         .custom-dropdown-icon {
//                                           position: absolute;
//                                           right: 5px;
//                                           bottom: 5px;
//                                           cursor: pointer;
//                                           font-size: 16px;

//                                           padding: 3px 6px;

//                                           user-select: none;
//                                         }

//                                         .custom-dropdown-icon:hover {
//                                           font-weight: bold;

//                                         }

//                                         .custom-dropdown {
//                                           position: absolute;
//                                           bottom: -300%; /* Display below input field */
//                                           right: 0px; /* Align to right inside input */
//                                           background: white;
//                                           border: 1px solid #ddd;
//                                           border-radius: 4px;
//                                           box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
//                                           width: 138px;
//                                           z-index: 10;
//                                         }

//                                         .dropdown-item {
//                                           padding: 8px;
//                                           cursor: pointer;
//                                           transition: background 0.2s;
//                                         }

//                                         .dropdown-item:hover {
//                                           background: #f1f1f1;
//                                         }
//                                       `}
//                                     </style>

//                                     {/* BUTTON INPUT BOXES */}
//                                     {templateHeadersList.buttonvariables.map(
//                                       (variable, index) => (
//                                         <div className="mb-3" key={index}>
//                                           <label
//                                             htmlFor={`templateVariable-${index}`}
//                                             className="form-label"
//                                           >
//                                             {`BUTTON VARIABLE #${index + 1}`}
//                                           </label>
//                                           <input
//                                             type="text"
//                                             id={`templateVariable-${index}`}
//                                             className="form-control"
//                                             value={
//                                               templateButtonVariables[index] ||
//                                               ""
//                                             }
//                                             placeholder={`Enter value for ${variable}`}
//                                             onChange={(e) =>
//                                               handleButtonVariableChange(
//                                                 index,
//                                                 e.target.value
//                                               )
//                                             }
//                                           />
//                                         </div>
//                                       )
//                                     )}
//                                   </div>

//                                   <div
//                                     className="template_preview"
//                                     style={{ maxWidth: "60%" }}
//                                   >
//                                     <label
//                                       htmlFor="templateBodyVariable1"
//                                       className="form-label"
//                                     >
//                                       Template View :
//                                     </label>
//                                     <div className="whatsapp-modal-content">
//                                       <div className="border p-2">
//                                         <div className="message_template">
//                                           {templateHeadersList.headerText && (
//                                             <div className="header-text fw-bold">
//                                               {getUpdatedHeaderText()}
//                                             </div>
//                                           )}

//                                           {templateHeadersList.templateText && (
//                                             <div
//                                               className="whatsapp-message"
//                                               dangerouslySetInnerHTML={{
//                                                 __html:
//                                                   getUpdatedTemplateText().replace(
//                                                     /\n/g,
//                                                     "<br>"
//                                                   ),
//                                               }}
//                                             />
//                                           )}
//                                         </div>
//                                         {templateHeadersList.buttons &&
//                                           templateHeadersList.buttons.length >
//                                             0 && (
//                                             <div
//                                               className={`d-flex gap-3 mt-2 mb-3 ${
//                                                 templateHeadersList.buttons
//                                                   .length > 2
//                                                   ? "flex-wrap"
//                                                   : ""
//                                               }`}
//                                             >
//                                               {templateHeadersList.buttons.map(
//                                                 (button, index) => (
//                                                   <a
//                                                     key={index}
//                                                     href={button.url}
//                                                     className="btn btn-success d-block mt-2 small_button"
//                                                     target="_blank"
//                                                     rel="noopener noreferrer"
//                                                     style={{
//                                                       flex:
//                                                         templateHeadersList
//                                                           .buttons.length > 2
//                                                           ? "1 1 calc(50% - 1.5rem)"
//                                                           : "unset",
//                                                     }}
//                                                   >
//                                                     {button.text}
//                                                   </a>
//                                                 )
//                                               )}
//                                             </div>
//                                           )}
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                               )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="text-end p-3">
//                       <button type="submit" className="btn btn-primary">
//                         Update
//                       </button>
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CampaignScheduleEditForm;

// =======================================FULL EDIT FORM======================================================
import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Select, { components } from "react-select";
import { toast } from "react-toastify";

const CampaignScheduleEditForm = () => {
  const templateCacheRef = useRef({});

  const [templateSearch, setTemplateSearch] = useState("");
  const searchDebounceRef = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const inputRefs = useRef([]);
  const [loading, setLoading] = useState(true);

  // States
  const [campaignDetails, setCampaignDetails] = useState("");
  const [campaignName, setCampaignName] = useState("");
  const [campaignType, setCampaignType] = useState("");
  const [scheduleDate, setScheduleDate] = useState("");
  const [audience, setAudience] = useState("");
  const [audienceCount, setAudienceCount] = useState(0);
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [endDate, setEndDate] = useState(startDate);
  const [campaignBatchId, setCampaignBatchId] = useState("");
  const [batchIds, setBatchIds] = useState([]);
  const [channelSelected, setChannelSelected] = useState(false);
  const [selectedChannelId, setSelectedChannelId] = useState("");
  const [selectedChannelConnectionName, setSelectedChannelConnectionName] =
    useState("");
  const [messageType, setMessageType] = useState("");

  const [selectedTemplateId, setSelectedTemplateId] = useState("");

  const [templateVariables, setTemplateVariables] = useState({});
  const [templateButtonVariables, setTemplateButtonVariables] = useState({});
  const [templateHeadersList, setTemplateHeadersList] = useState({
    inputvariables: [],
    buttonvariables: [],
    buttons: [], // ✅ ADD THIS
    headervariables: [],
    headerText: "",
    templateText: "",
  });
  const [templateHeaderVariables, setTemplateHeaderVariables] = useState("");
  const [templateHeaderImage, setTemplateHeaderImage] = useState("");
  const [templateHeaderVideo, setTemplateHeaderVideo] = useState("");
  const [templateHeaderDocument, setTemplateHeaderDocument] = useState("");
  const [templateMessage, setTemplateMessage] = useState(null);
  const [templateList, setTemplateList] = useState([]);
  const [templateTotal, setTemplateTotal] = useState(0);
  const [templatePage, setTemplatePage] = useState(1);
  const TEMPLATE_LIMIT = 20;

  const [channelList, setChannelList] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const [batchData, setBatchData] = useState([]);

  const predefinedOptions = ["{{name}}", "{{email}}", "{{phone}}"];
  const [predefinedTemplates, setPredefinedTemplates] = useState([]);

  const handleTemplateSearch = (inputValue) => {
    setTemplateSearch(inputValue);

    if (inputValue.length < 2) return; // 🔥 MIN 2 CHAR SEARCH

    clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      fetchTemplateListVersionTwo(inputValue, 1, false);
    }, 300); // 🔥 faster debounce
  };

  useEffect(() => {
    const fetchPredefinedTemplates = async () => {
      try {
        const response = await axios.get("/api/predefinedtemplate/getall");
        console.log(response);
        setPredefinedTemplates(response.data.data);
      } catch (error) {
        console.error("Failed to fetch predefined templates:", error);
      }
    };

    fetchPredefinedTemplates();
  }, []);

  const fetchBatchDetails = async (campaignId) => {
    try {
      const response = await axios.get(
        `/api/campaignscheduler/getcampaign/${campaignId}`
      );
      if (response.status === 200) {
        setAudienceCount(response.data.length);
        setBatchData(response.data);
        console.log("BAtch DAta", response.data);
      } else {
        console.error("Failed to fetch Audience");
      }
    } catch (error) {
      console.error("Error fetching batch details:", error);
    }
  };

  useEffect(() => {
    const fetchCampaignData = async () => {
      try {
        const response = await axios.get(
          `/api/campaignscheduler/get_campaign_scheduler/${id}`
        );
        const data = response.data;

        console.log(response);

        setCampaignDetails(data.campaignDetails || "");
        setCampaignName(data.campaignName || "");
        setCampaignType(data.campaignType || "");
        setScheduleDate(data.scheduleDate || "");
        setAudience(data.audience || "");
        setStartDate(data.startDate || new Date().toISOString().split("T")[0]);
        setCampaignBatchId(data.campaignBatchId || "");
        setChannelSelected(data.channelSelected || false);
        setSelectedChannelId(data.selectedChannelId || "");
        setSelectedChannelConnectionName(
          data.selectedChannelConnectionName || ""
        );
        setMessageType(data.messageType || "");
        setTemplateVariables(data.templateVariables || {});
        setTemplateButtonVariables(data.templateButtonVariables || {});
        // setTemplateMessage(data.templateHeadersList.data.name || "");
        setSelectedPredefinedTemplateId(data.predefinedTemplateId || "");

        // setTemplateMessage(data.templateHeadersList.data.id || "");
        setTemplateMessage({
          value: data.templateHeadersList.data.id,
          label: data.templateHeadersList.data.name,
        });
        setTemplateHeadersList(
          data.templateHeadersList || {
            inputvariables: [],
            buttonvariables: [],
          }
        );
        setTemplateHeaderVariables(data.updatedHeaderText || "");
        setTemplateHeaderImage(data.updatedHeaderImage || "");
        setTemplateHeaderVideo(data.updatedHeaderVideo || "");
        setTemplateHeaderDocument(data.updatedHeaderDocument || "");

        // ✅ Pass preselected batch ID to avoid overwriting
        await fetchBatchIds(data.startDate, data.campaignBatchId);
      } catch (error) {
        toast.error("Unable to load campaign data for duplication");
      }
    };

    fetchCampaignData();
  }, [id]);

  console.log(messageType);
  console.log(templateMessage);

  const fetchBatchIds = async (date, preselectedBatchId = "") => {
    try {
      const isoDate = new Date(date).toISOString().split("T")[0];
      const response = await axios.get(
        `/api/campaignscheduler/getfiltercampaign`,
        {
          params: { startDate: isoDate, endDate: date },
        }
      );

      if (response.status === 200) {
        const batchList = response.data.contact;
        setBatchIds(batchList);

        // ✅ Only set default if there's no preselected value
        if (!preselectedBatchId) {
          const firstBatchId =
            batchList.length > 0 && batchList[0] !== "No campaigns available"
              ? batchList[0]
              : "";
          setCampaignBatchId(firstBatchId);

          if (firstBatchId) {
            fetchBatchDetails(firstBatchId);
          }
        } else {
          // If we already have a preselected one, just fetch its details
          fetchBatchDetails(preselectedBatchId);
        }
      } else {
        console.error("Failed to fetch batch IDs:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching batch IDs:", error);
    }
  };

  const fetchChannelData = async () => {
    try {
      const response = await axios.get("/api/campaignscheduler/getallchannel");
      setChannelList(response.data);
      // console.log("Channel List :", response.data);
    } catch (error) {
      console.error("Failed to fetch channels:", error);
    }
  };

  const fetchChannelListData = async () => {
    try {
      const response = await axios.get(
        "/api/campaignscheduler/getallchannellist"
      );
      setChannelList(response.data);
      // console.log("Channel List :", response.data);
    } catch (error) {
      console.error("Failed to fetch channels:", error);
    }
  };

  useEffect(() => {
    if (campaignDetails === "WA Cloud") {
      fetchChannelData();
    } else if (campaignDetails === "WA Team") {
      fetchChannelListData();
    }
  }, [campaignDetails]);

  const [visibleOptions, setVisibleOptions] = useState(7);
  const loadingMoreRef = useRef(false);
  // const options = templateList.map((template) => ({
  //   value: template.id,
  //   label: `${template.name} - 🟢${template.status} - 🟠${template.category}`,
  // }));

  const options = useMemo(() => {
    return templateList.map((template) => ({
      value: template.id,
      label: `${template.name} - 🟢${template.status} - 🟠${template.category}`,
    }));
  }, [templateList]);

  // const MenuList = (props) => {
  //   const { children } = props;

  //   // Normal options + See More button
  //   return (
  //     <components.MenuList {...props}>
  //       {children}
  //       {options.length > visibleOptions && (
  //         <div
  //           style={{
  //             padding: "8px",
  //             textAlign: "center",
  //             cursor: "pointer",
  //             color: "blue",
  //             fontWeight: "500",
  //           }}
  //           onClick={(e) => {
  //             e.stopPropagation(); // prevent selecting
  //             setVisibleOptions((prev) => prev + 7);
  //           }}
  //         >
  //           See More
  //         </div>
  //       )}
  //     </components.MenuList>
  //   );
  // };

  const menuScrollRef = useRef(0);

  const MenuList = (props) => {
    const { children, innerRef, innerProps } = props;

    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;

      // 🔐 scroll position save
      menuScrollRef.current = scrollTop;

      // bottom reached
      if (
        scrollTop + clientHeight >= scrollHeight - 10 &&
        templateList.length < templateTotal &&
        !loading
      ) {
        fetchTemplateListVersionTwo(templateSearch, templatePage + 1, true);
      }
    };

    return (
      <div
        ref={(node) => {
          // react-select internal ref
          innerRef(node);

          // 🔐 scroll restore after re-render
          if (node) {
            node.scrollTop = menuScrollRef.current;
          }
        }}
        {...innerProps}
        onScroll={handleScroll}
        style={{
          maxHeight: 300,
          overflowY: "auto",
        }}
      >
        {children}
      </div>
    );
  };

  const fetchTemplateList = async () => {
    if (!selectedChannelId || templateList.length > 0) return;

    setLoading(true);
    try {
      const response = await axios.get(
        `/api/campaignscheduler/${selectedChannelId}/getalltemplateapproved`
      );
      // setTemplateList(response.data);
      const templates = Array.isArray(response.data)
        ? response.data
        : response.data.data || [];

      setTemplateList(templates);
      console.log("Template List :", response.data);
    } catch (error) {
      console.error("Failed to fetch templates:", error);
      toast.error("Failed to fetch templates Cloud. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // const fetchTemplateListVersionTwo = async () => {
  //   if (!selectedChannelId) return;

  //   setLoading(true);
  //   try {
  //     const response = await axios.get(
  //       `/api/campaignscheduler/${selectedChannelId}/getalltemplateapprovedversiontwo`
  //     );
  //     // setTemplateList(response.data);
  //     // ✅ FIX HERE
  //     const templates = Array.isArray(response.data)
  //       ? response.data
  //       : response.data.data || [];

  //     setTemplateList(templates);
  //     console.log("Template List Version Two :", response.data);
  //   } catch (error) {
  //     console.error("Failed to fetch templates:", error);
  //     toast.error("Failed to fetch templates V2. Please try again later.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (selectedChannelId) {
  //     if (campaignDetails === "WA Cloud") {
  //       fetchTemplateList();
  //     } else if (campaignDetails === "WA Team") {
  //       fetchTemplateListVersionTwo();
  //     }
  //   }
  // }, [selectedChannelId]);

  const fetchTemplateListVersionTwo = async (
    searchText = "",
    page = 1,
    append = false
  ) => {
    if (!selectedChannelId || loadingMoreRef.current) return;

    const cacheKey = `${selectedChannelId}_${searchText}_${page}`;

    // 🔥 CACHE HIT
    if (templateCacheRef.current[cacheKey]) {
      const cached = templateCacheRef.current[cacheKey];
      setTemplateTotal(cached.total);
      setTemplatePage(page);
      setTemplateList((prev) =>
        append ? [...prev, ...cached.data] : cached.data
      );
      return;
    }

    loadingMoreRef.current = true;
    setLoading(true);

    try {
      const response = await axios.get(
        `/api/campaignscheduler/${selectedChannelId}/getalltemplateapprovedversiontwo`,
        {
          params: { search: searchText, page, limit: TEMPLATE_LIMIT },
        }
      );

      const { data, total } = response.data;

      // 🔥 SAVE CACHE
      templateCacheRef.current[cacheKey] = { data, total };

      setTemplateTotal(total);
      setTemplatePage(page);
      setTemplateList((prev) => (append ? [...prev, ...data] : data));
    } finally {
      setLoading(false);
      loadingMoreRef.current = false;
    }
  };

  useEffect(() => {
    if (selectedChannelId) {
      if (campaignDetails === "WA Cloud") {
        fetchTemplateList();
      } else if (campaignDetails === "WA Team") {
        fetchTemplateListVersionTwo();
      }
    }
  }, [selectedChannelId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      campaignDetails,
      campaignName,
      campaignType,
      scheduleDate: campaignType === "Immediate" ? "" : scheduleDate,
      audience,
      startDate,
      campaignBatchId,
      channelSelected,
      selectedChannelId,
      selectedChannelConnectionName,
      messageType,
      templateVariables,
      templateButtonVariables,
      templateMessage,
      templateHeadersList,
      templateHeaderVariables,
      templateHeaderImage,
      templateHeaderVideo,
      updatedTemplateText: updatedTemplateText,
      updatedTemplateButton: updatedTemplateButton,
      updatedHeaderText: updatedHeaderText,
      updatedHeaderImage: updatedHeaderImage,
      updatedHeaderVideo: updatedHeaderVideo,
      updatedHeaderDocument: updatedHeaderDocument,
      templateHeaderDocument,
    };

    console.log(formData);

    try {
      const response = await axios.put(
        `/api/campaignscheduler/update_campaign_scheduler/${id}`,
        formData
      );
      if (response.status === 201 || response.status === 200) {
        toast.success("Campaign updated successfully!");
        navigate(-1);
      }
    } catch (error) {
      toast.error("Failed to update campaign. Try again!");
    }
  };

  // Handlers for form fields
  const handleCampaignDetailsChange = (e) => setCampaignDetails(e.target.value);
  const handleCampaignNameChange = (e) => setCampaignName(e.target.value);
  const handleCampaignTypeChange = (e) => setCampaignType(e.target.value);
  const handleScheduleDateChange = (e) => setScheduleDate(e.target.value);
  const handleAudienceChange = (e) => setAudience(e.target.value);
  // const handleDateChange = (e) => setStartDate(e.target.value);

  const handleDateChange = async (e) => {
    const date = e.target.value;
    setStartDate(date);
    setEndDate(date);

    if (date) {
      fetchBatchIds(date);
    }
  };

  const handleBatchChange = async (event) => {
    const campaignId = event.target.value;
    setCampaignBatchId(campaignId);

    if (campaignId) {
      fetchBatchDetails(campaignId);
    }
  };

  const handleChannelChange = (e) => {
    const channelData = JSON.parse(e.target.value);
    setSelectedChannelId(channelData.id);
    setSelectedChannelConnectionName(channelData.name);
    setChannelSelected(true);
  };
  const handleMessageTypeChange = (e) => setMessageType(e.target.value);
  // const handleTemplateHeadersChange = (e) => setTemplateMessage(e.target.value);

  const handleTemplateHeadersChange = (event) => {
    const templateId = event.target.value;
    setSelectedTemplateId(templateId);
  };

  const [selectedPredefinedTemplateId, setSelectedPredefinedTemplateId] =
    useState("");

  const handlePredefinedTemplateSelect = (templateId) => {
    const selectedTemplate = predefinedTemplates.find(
      (template) => template._id === templateId
    );

    if (selectedTemplate) {
      const values = selectedTemplate.predefinedtemplate || [];

      const headerVarCount = templateHeadersList.headervariables.length || 0;
      const bodyVarCount = templateHeadersList.inputvariables.length || 0;
      const buttonVarCount = templateHeadersList.buttonvariables?.length || 0;

      const headerVars = {};
      const bodyVars = {};
      const buttonVars = {};

      let index = 0;

      // Fill HEADER VARIABLES first
      for (let i = 0; i < headerVarCount; i++) {
        headerVars[i] = values[index] || "";
        index++;
      }

      // Fill BODY VARIABLES next
      for (let i = 0; i < bodyVarCount; i++) {
        bodyVars[i] = values[index] || "";
        index++;
      }

      // Fill BUTTON VARIABLES last
      for (let i = 0; i < buttonVarCount; i++) {
        buttonVars[i] = values[index] || "";
        index++;
      }

      setTemplateHeaderVariables(headerVars);
      setTemplateVariables(bodyVars);
      setTemplateButtonVariables(buttonVars);
    }
  };

  // const handleHeaderVariableChange = (index, value) => {
  //   setTemplateHeaderVariables((prev) => ({ ...prev, [index]: value }));
  // };

  const handleHeaderVariableChange = (value) => {
    setTemplateHeaderVariables(value);
  };
  const handleHeaderImageChange = (e) => setTemplateHeaderImage(e.target.value);
  const handleHeaderVideoChange = (e) => setTemplateHeaderVideo(e.target.value);

  const handleHeaderDocumentChange = (e) =>
    setTemplateHeaderDocument(e.target.value);

  const handleInsertVariableChange = (index, value) => {
    setTemplateVariables((prev) => ({ ...prev, [index]: value }));
  };

  const handleInsertText = (index, value) => {
    setTemplateVariables((prev) => ({
      ...prev,
      [index]: (prev[index] || "") + value,
    }));
    setDropdownOpen(null);
  };

  const handleButtonVariableChange = (index, value) => {
    setTemplateButtonVariables((prev) => ({ ...prev, [index]: value }));
  };

  const getUpdatedTemplateText = () => {
    // Replace placeholders in templateText with corresponding values from templateVariables
    let updatedText = templateHeadersList.templateText;
    templateHeadersList.inputvariables.forEach((variable, index) => {
      const placeholder = new RegExp(`\\{\\{${index + 1}\\}\\}`, "g"); // Match {{1}}, {{2}}, etc.
      updatedText = updatedText.replace(
        placeholder,
        templateVariables[index] || variable
      ); // Replace with input value or leave placeholder
    });
    // console.log("UpdatedText", updatedText);
    return updatedText;
  };

  // const getUpdatedTemplateButton = () => {
  //   if (!templateHeadersList || !Array.isArray(templateHeadersList.buttons)) {
  //     console.error(
  //       "Error: templateHeadersList.buttons is undefined or not an array."
  //     );
  //     return [];
  //   }

  //   let updatedButtons = templateHeadersList.buttons.map(
  //     (button, buttonIndex) => {
  //       let updatedButton = { ...button };

  //       if (
  //         updatedButton.url &&
  //         Array.isArray(templateHeadersList.buttonvariables)
  //       ) {
  //         // Each button gets its index-mapped value from templateButtonVariables
  //         const variable = templateHeadersList.buttonvariables[buttonIndex]; // Get the corresponding placeholder
  //         if (variable) {
  //           const replacementValue = templateButtonVariables[buttonIndex] ?? ""; // Map to templateButtonVariables index

  //           updatedButton.url = updatedButton.url.replace(
  //             variable,
  //             replacementValue
  //           );
  //         }
  //       }

  //       return updatedButton;
  //     }
  //   );

  //   return updatedButtons;
  // };

  const getUpdatedTemplateButton = () => {
    if (!Array.isArray(templateHeadersList?.buttons)) {
      return [];
    }

    return templateHeadersList.buttons.map((button, buttonIndex) => {
      let updatedButton = { ...button };

      if (
        updatedButton.url &&
        Array.isArray(templateHeadersList.buttonvariables)
      ) {
        const replacementValue = templateButtonVariables[buttonIndex] ?? "";

        updatedButton.url = updatedButton.url.replace(
          templateHeadersList.buttonvariables[buttonIndex],
          replacementValue
        );
      }

      return updatedButton;
    });
  };

  const getUpdatedHeaderText = () => {
    let updatedHeaderText = templateHeadersList?.headerText || "";

    if (Array.isArray(templateHeadersList?.headervariables)) {
      templateHeadersList.headervariables.forEach((variable, index) => {
        const placeholder = new RegExp(`\\{\\{${index + 1}\\}\\}`, "g");
        updatedHeaderText = updatedHeaderText.replace(
          placeholder,
          templateHeaderVariables || variable
        );
      });
    }

    return updatedHeaderText;
  };

  const getUpdatedHeaderImage = () => {
    // console.log("Template Header List", templateHeadersList.headerImageUrl);
    let updatedHeaderImage = templateHeadersList.headerImageUrl;

    // Directly replace headerImageUrl with user input from templateHeaderImage
    if (templateHeaderImage) {
      updatedHeaderImage = templateHeaderImage;
    }

    // console.log("updatedHeaderImage", updatedHeaderImage);
    return updatedHeaderImage;
  };

  const getUpdatedHeaderVideo = () => {
    // console.log("Template Header List", templateHeadersList.headerVideoUrl);
    let updatedHeaderVideo = templateHeadersList.headerVideoUrl;

    // Directly replace headerImageUrl with user input from templateHeaderVideo
    if (templateHeaderVideo) {
      updatedHeaderVideo = templateHeaderVideo;
    }

    // console.log("updatedHeaderImage", updatedHeaderVideo);
    return updatedHeaderVideo;
  };

  const getUpdatedHeaderDocument = () => {
    // console.log("Template Header List", templateHeadersList.headerPdfUrl);
    let updatedHeaderDocument = templateHeadersList.headerPdfUrl;

    // Directly replace headerImageUrl with user input from templateHeaderDocument
    if (templateHeaderDocument) {
      updatedHeaderDocument = templateHeaderDocument;
    }

    // console.log("updatedHeaderDocument", updatedHeaderDocument);
    return updatedHeaderDocument;
  };

  const updatedTemplateText = getUpdatedTemplateText();
  const updatedTemplateButton = getUpdatedTemplateButton();
  const updatedHeaderText = getUpdatedHeaderText();
  const updatedHeaderImage = getUpdatedHeaderImage();
  const updatedHeaderVideo = getUpdatedHeaderVideo();
  const updatedHeaderDocument = getUpdatedHeaderDocument();

  // useEffect(() => {
  //   if (templateList.length > 0 && templateMessage) {
  //     handleTemplateHeadersChange({ target: { value: templateMessage } });
  //   }
  // }, [templateList, templateMessage]);

  useEffect(() => {
    if (templateMessage?.value) {
      handleTemplateHeadersChange({
        target: { value: templateMessage.value },
      });
    }
  }, [templateMessage]);

  useEffect(() => {
    const fetchTemplateHeaders = async () => {
      if (!selectedTemplateId || !selectedChannelId) return; // Only fetch if both are selected
      console.log(selectedTemplateId);
      try {
        const response = await axios.get(
          `/api/campaignscheduler/${selectedChannelId}/gettemplate/${selectedTemplateId}`
        );
        setTemplateHeadersList(response.data || []);
      } catch (error) {
        console.error("Failed to fetch template headers:", error);
      }
    };

    fetchTemplateHeaders();
  }, [selectedChannelId, selectedTemplateId]);

  return (
    <div className="page-content w-100">
      <div className="container mt-5">
        <div className="row">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <h4>Campaign Scheduler Edit Form</h4>
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => navigate(-1)}
            >
              &larr; Back
            </button>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="d-flex gap-3 flex-column">
                    <div
                      className="d-flex gap-2"
                      style={{
                        padding: "10px 15px",
                      }}
                    >
                      {/* Campaign Details */}
                      <div
                        className="mx-auto"
                        style={{
                          padding: "10px 15px",
                          width: "33.33%",
                        }}
                      >
                        <div className="mb-2">
                          <label className="form-label fw-bold">
                            Campaign Details:
                          </label>
                          <div className="d-flex gap-3 mt-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="campaignDetailsOptions"
                                id="campaignDetails1"
                                value="WA Cloud"
                                checked={campaignDetails === "WA Cloud"}
                                onChange={handleCampaignDetailsChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="campaignDetails1"
                              >
                                WA Cloud
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="campaignDetailsOptions"
                                id="campaignDetails2"
                                value="WA Team"
                                checked={campaignDetails === "WA Team"}
                                onChange={handleCampaignDetailsChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="campaignDetails2"
                              >
                                WA Team
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Campaing Name */}
                      <div
                        className="mx-auto"
                        style={{
                          padding: "10px 15px",
                          width: "33.33%",
                        }}
                      >
                        <div className="mb-2">
                          <label
                            className="form-label fw-bold"
                            htmlFor="campaignName"
                          >
                            Campaign Name:
                          </label>
                          <input
                            type="text"
                            id="campaignName"
                            className="form-control"
                            placeholder="Enter Campaign Name"
                            value={campaignName}
                            onChange={handleCampaignNameChange}
                          />
                        </div>
                      </div>
                      {/* Campaign Type */}
                      <div
                        className="mx-auto"
                        style={{
                          padding: "10px 15px",
                          width: "33.33%",
                        }}
                      >
                        <div className="mb-2">
                          <label className="form-label fw-bold">
                            Campaign Type:
                          </label>
                          <div>
                            <div className="d-flex gap-3 mt-2">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="campaignTypeOptions"
                                  id="campaignType1"
                                  value="Immediate"
                                  checked={campaignType === "Immediate"}
                                  onChange={handleCampaignTypeChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="campaignType1"
                                >
                                  Immediate
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="campaignTypeOptions"
                                  id="campaignType2"
                                  value="Schedule"
                                  checked={campaignType === "Schedule"}
                                  onChange={handleCampaignTypeChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="campaignType2"
                                >
                                  Schedule
                                </label>
                              </div>
                            </div>

                            {campaignType === "Schedule" && (
                              <div className="mt-2">
                                <label
                                  htmlFor="dateTimeSelect"
                                  className="form-label"
                                >
                                  Schedule Date & Time:
                                </label>
                                <input
                                  type="datetime-local"
                                  className="form-control"
                                  id="dateTimeSelect"
                                  // value={scheduleDate}
                                  value={new Date(scheduleDate)
                                    .toLocaleString("sv-SE", {
                                      timeZone: "Asia/Kolkata",
                                    })
                                    .replace(" ", "T")}
                                  onChange={handleScheduleDateChange}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="d-flex gap-2"
                      style={{
                        padding: "10px 15px",
                      }}
                    >
                      <div
                        className="mx-auto"
                        style={{
                          width: "40%",
                          padding: "10px 15px",
                        }}
                      >
                        <div className="mb-2">
                          <div>
                            <label className="form-label fw-bold">
                              Audience: {audienceCount}
                            </label>
                          </div>
                          <div>
                            <div className="d-flex gap-3 mt-1">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="AudienceOptions"
                                  id="Audience1"
                                  value="All Contacts"
                                  checked={audience === "All Contacts"}
                                  onChange={handleAudienceChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="Audience1"
                                >
                                  All Contacts from CRM
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="AudienceOptions"
                                  id="Audience2"
                                  value="Segmented"
                                  checked={audience === "Segmented"}
                                  onChange={handleAudienceChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="Audience2"
                                >
                                  Segmented
                                </label>
                              </div>
                            </div>

                            {audience === "Segmented" && (
                              <div className="d-flex gap-3 mt-3">
                                <div className="mt-3">
                                  <label
                                    htmlFor="dateSelect"
                                    className="form-label"
                                  >
                                    Campaign Date:
                                  </label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    id="dateSelect"
                                    // value={startDate}

                                    value={new Date(
                                      startDate
                                    ).toLocaleDateString("sv-SE", {
                                      timeZone: "Asia/Kolkata",
                                    })}
                                    onChange={handleDateChange}
                                  />
                                </div>

                                <div className="mt-3">
                                  <label
                                    htmlFor="batchSelect"
                                    className="form-label"
                                  >
                                    Campaign Batch ID:
                                  </label>

                                  <select
                                    id="batchSelect"
                                    className="form-select"
                                    value={campaignBatchId || ""}
                                    onChange={handleBatchChange}
                                    disabled={!batchIds.length}
                                  >
                                    {batchIds.length ? (
                                      <>
                                        <option value="" disabled>
                                          Select an option
                                        </option>
                                        {batchIds.map((id) => (
                                          <option key={id} value={id}>
                                            {id}
                                          </option>
                                        ))}
                                      </>
                                    ) : (
                                      <option value="" disabled>
                                        No batch IDs found
                                      </option>
                                    )}
                                  </select>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="mx-auto"
                        style={{
                          width: "60%",
                          padding: "10px 15px",
                        }}
                      >
                        <div className="mb-2">
                          <div>
                            <label className="form-label fw-bold">
                              Template:
                            </label>
                          </div>
                          <div>
                            <div className="d-flex gap-5 align-items-center">
                              <label
                                htmlFor="channelSelect"
                                className="form-label"
                              >
                                Channel:
                              </label>
                              <select
                                id="channelSelect"
                                className="form-select"
                                aria-label="Select a channel"
                                onChange={handleChannelChange}
                                // disabled={campaignDetails !== "WA Cloud"}
                                disabled={
                                  !(
                                    campaignDetails === "WA Cloud" ||
                                    campaignDetails === "WA Team"
                                  )
                                }
                                value={
                                  selectedChannelId
                                    ? JSON.stringify({
                                        id: selectedChannelId,
                                        name: selectedChannelConnectionName,
                                      })
                                    : ""
                                }
                              >
                                <option value="" disabled selected>
                                  Select an option
                                </option>
                                {channelList.map((channel) => (
                                  <option
                                    key={channel._id}
                                    value={JSON.stringify({
                                      id: channel._id,
                                      name: channel.connectionname,
                                    })}
                                  >
                                    {channel.connectionname}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {channelSelected && (
                              <div className="mt-3">
                                <label
                                  htmlFor="channelSelect"
                                  className="form-label"
                                >
                                  Message Type:
                                </label>
                                <div className="d-flex gap-5 mt-2">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="TemplateOptions"
                                      id="template1"
                                      value="Pre-Approved"
                                      checked={messageType === "Pre-Approved"}
                                      onChange={handleMessageTypeChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="template1"
                                    >
                                      Pre-Approved Template
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="TemplateOptions"
                                      id="template2"
                                      value="Regular Message"
                                      checked={
                                        messageType === "Regular Message"
                                      }
                                      onChange={handleMessageTypeChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="template2"
                                    >
                                      Regular Message
                                    </label>
                                  </div>
                                </div>
                              </div>
                            )}

                            {messageType === "Pre-Approved" && (
                              <div className="mt-3">
                                <label
                                  htmlFor="templateSelect"
                                  className="form-label"
                                >
                                  Template:
                                </label>
                                {/* <Select
                                  inputId="templateSelect"
                                  // options={options}
                                  options={options.slice(0, visibleOptions)}
                                  components={{ MenuList }}
                                  // onChange={(selectedOption) =>
                                  //   handleTemplateHeadersChange({
                                  //     target: { value: selectedOption.value },
                                  //   })
                                  // }
                                  onChange={(selectedOption) => {
                                    // state update karo
                                    setTemplateMessage(selectedOption.value);

                                    // Reset niche ka form
                                    setTemplateHeaderVariables([]);
                                    setTemplateHeaderImage(null);
                                    setTemplateHeaderVideo(null);
                                    setTemplateHeaderDocument(null);
                                    setTemplateVariables([]);
                                    setTemplateButtonVariables([]);

                                    // agar aapko pehle se defined function bhi chalana hai
                                    handleTemplateHeadersChange({
                                      target: { value: selectedOption.value },
                                    });
                                  }}
                                  value={
                                    options.find(
                                      (opt) => opt.value === templateMessage
                                    ) || null
                                  }
                                  placeholder="Select a template..."
                                  isSearchable
                                  isLoading={templateList.length === 0}
                                /> */}
                                <Select
                                  inputId="templateSelect"
                                  menuShouldScrollIntoView={false}
                                  blurInputOnSelect
                                  options={options}
                                  components={{ MenuList }}
                                  isSearchable
                                  placeholder="Search template..."
                                  isLoading={loading}
                                  onInputChange={handleTemplateSearch}
                                  onMenuOpen={() =>
                                    fetchTemplateListVersionTwo(
                                      templateSearch,
                                      1,
                                      false
                                    )
                                  }
                                  onChange={(selectedOption) => {
                                    if (!selectedOption) return;

                                    // template value set
                                    setTemplateMessage(selectedOption);

                                    // niche ka form reset
                                    setTemplateHeaderVariables([]);
                                    setTemplateHeaderImage(null);
                                    setTemplateHeaderVideo(null);
                                    setTemplateHeaderDocument(null);
                                    setTemplateVariables([]);
                                    setTemplateButtonVariables([]);

                                    // same handler jo create me use ho raha hai
                                    handleTemplateHeadersChange({
                                      target: { value: selectedOption.value },
                                    });
                                  }}
                                  // value={
                                  //   options.find(
                                  //     (opt) => opt.value === templateMessage
                                  //   ) || null
                                  // }
                                  value={templateMessage}
                                />
                              </div>
                            )}

                            {/* Dynamic Input Boxes */}
                            {templateHeadersList.inputvariables &&
                              templateHeadersList.inputvariables.length > 0 && (
                                <div className="d-flex gap-3 mt-4">
                                  <div
                                    className="input_variables"
                                    style={{
                                      maxWidth: "40%",
                                    }}
                                  >
                                    {/* PREDEFINED TEMPLATES SELECT */}
                                    <select
                                      className="form-select mb-3"
                                      value={selectedPredefinedTemplateId}
                                      onChange={(e) =>
                                        handlePredefinedTemplateSelect(
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="" disabled selected>
                                        Select pre-template
                                      </option>
                                      {predefinedTemplates.map((template) => (
                                        <option
                                          key={template._id}
                                          value={template._id}
                                        >
                                          {template.templatename}
                                        </option>
                                      ))}
                                    </select>

                                    {/* HEADER INPUTS BASED ON headerFormat */}
                                    {templateHeadersList.headerFormat ===
                                      "TEXT" &&
                                      templateHeadersList.headervariables.map(
                                        (variable, index) => (
                                          <div className="mb-3" key={index}>
                                            <label
                                              htmlFor={`templateVariable-${index}`}
                                              className="form-label"
                                            >
                                              {`HEADER VARIABLE #${index + 1}`}
                                            </label>
                                            <input
                                              type="text"
                                              id={`templateVariable-${index}`}
                                              className="form-control"
                                              placeholder={`Enter value for ${variable}`}
                                              value={
                                                templateHeaderVariables || ""
                                              }
                                              onChange={(e) =>
                                                handleHeaderVariableChange(
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                        )
                                      )}

                                    {templateHeadersList.headerFormat ===
                                      "IMAGE" && (
                                      <div className="mb-3">
                                        <label
                                          htmlFor="headerImageUpload"
                                          className="form-label"
                                        >
                                          HEADER IMAGE:
                                        </label>
                                        <input
                                          type="text"
                                          id="headerImageUpload"
                                          className="form-control"
                                          placeholder="Enter image URL"
                                          value={templateHeaderImage || ""}
                                          onChange={handleHeaderImageChange}
                                        />
                                      </div>
                                    )}

                                    {templateHeadersList.headerFormat ===
                                      "VIDEO" && (
                                      <div className="mb-3">
                                        <label
                                          htmlFor="headerVideoUpload"
                                          className="form-label"
                                        >
                                          HEADER VIDEO:
                                        </label>
                                        <input
                                          type="text"
                                          id="headerVideoUpload"
                                          className="form-control"
                                          placeholder="Enter video URL"
                                          value={templateHeaderVideo || ""}
                                          onChange={handleHeaderVideoChange}
                                        />
                                      </div>
                                    )}

                                    {templateHeadersList.headerFormat ===
                                      "DOCUMENT" && (
                                      <div className="mb-3">
                                        <label
                                          htmlFor="headerDocumentUpload"
                                          className="form-label"
                                        >
                                          HEADER DOCUMENT:
                                        </label>
                                        <input
                                          type="text"
                                          id="headerDocumentUpload"
                                          className="form-control"
                                          placeholder="Enter document URL"
                                          value={templateHeaderDocument || ""}
                                          onChange={handleHeaderDocumentChange}
                                        />
                                      </div>
                                    )}

                                    {/* BODY INPUT BOXES */}

                                    {templateHeadersList.inputvariables.map(
                                      (variable, index) => (
                                        <div
                                          className="mb-3 position-relative"
                                          key={index}
                                        >
                                          <label className="form-label">{`BODY VARIABLE #${
                                            index + 1
                                          }`}</label>
                                          <div className="input-container">
                                            {/* Input Field */}
                                            <input
                                              type="text"
                                              ref={(el) =>
                                                (inputRefs.current[index] = el)
                                              }
                                              className="form-control custom-input"
                                              placeholder={`Enter value for ${variable}`}
                                              value={
                                                templateVariables[index] || ""
                                              }
                                              onChange={(e) =>
                                                handleInsertVariableChange(
                                                  index,
                                                  e.target.value
                                                )
                                              }
                                            />

                                            {/* Dropdown Icon Inside Input Field */}
                                            <span
                                              className="custom-dropdown-icon"
                                              onClick={() =>
                                                setDropdownOpen(
                                                  dropdownOpen === index
                                                    ? null
                                                    : index
                                                )
                                              }
                                            >
                                              &lt;&gt;
                                            </span>

                                            {/* Dropdown Inside Input Field */}
                                            {dropdownOpen === index && (
                                              <div className="custom-dropdown">
                                                {predefinedOptions.map(
                                                  (option, idx) => (
                                                    <div
                                                      key={idx}
                                                      className="dropdown-item"
                                                      onClick={() =>
                                                        handleInsertText(
                                                          index,
                                                          option
                                                        )
                                                      }
                                                    >
                                                      {option}
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )
                                    )}

                                    <style>
                                      {`
                                        .input-container {
                                          position: relative;
                                          display: flex;
                                          align-items: center;
                                        }

                                        .custom-input {
                                          width: 100%;
                                          padding-right: 35px; /* Space for the dropdown icon */
                                        }

                                        .custom-dropdown-icon {
                                          position: absolute;
                                          right: 5px;
                                          bottom: 5px;
                                          cursor: pointer;
                                          font-size: 16px;
                                          
                                          padding: 3px 6px;
                                          
                                          user-select: none;
                                        }

                                        .custom-dropdown-icon:hover {
                                          font-weight: bold;
                                          
                                        }

                                        .custom-dropdown {
                                          position: absolute;
                                          bottom: -300%; /* Display below input field */
                                          right: 0px; /* Align to right inside input */
                                          background: white;
                                          border: 1px solid #ddd;
                                          border-radius: 4px;
                                          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
                                          width: 138px;
                                          z-index: 10;
                                        }

                                        .dropdown-item {
                                          padding: 8px;
                                          cursor: pointer;
                                          transition: background 0.2s;
                                        }

                                        .dropdown-item:hover {
                                          background: #f1f1f1;
                                        }
                                      `}
                                    </style>

                                    {/* BUTTON INPUT BOXES */}
                                    {templateHeadersList.buttonvariables.map(
                                      (variable, index) => (
                                        <div className="mb-3" key={index}>
                                          <label
                                            htmlFor={`templateVariable-${index}`}
                                            className="form-label"
                                          >
                                            {`BUTTON VARIABLE #${index + 1}`}
                                          </label>
                                          <input
                                            type="text"
                                            id={`templateVariable-${index}`}
                                            className="form-control"
                                            value={
                                              templateButtonVariables[index] ||
                                              ""
                                            }
                                            placeholder={`Enter value for ${variable}`}
                                            onChange={(e) =>
                                              handleButtonVariableChange(
                                                index,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      )
                                    )}
                                  </div>

                                  <div
                                    className="template_preview"
                                    style={{ maxWidth: "60%" }}
                                  >
                                    <label
                                      htmlFor="templateBodyVariable1"
                                      className="form-label"
                                    >
                                      Template View :
                                    </label>
                                    <div className="whatsapp-modal-content">
                                      <div className="border p-2">
                                        <div className="message_template">
                                          {templateHeadersList.headerText && (
                                            <div className="header-text fw-bold">
                                              {getUpdatedHeaderText()}
                                            </div>
                                          )}

                                          {templateHeadersList.templateText && (
                                            <div
                                              className="whatsapp-message"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  getUpdatedTemplateText().replace(
                                                    /\n/g,
                                                    "<br>"
                                                  ),
                                              }}
                                            />
                                          )}
                                        </div>
                                        {templateHeadersList.buttons &&
                                          templateHeadersList.buttons.length >
                                            0 && (
                                            <div
                                              className={`d-flex gap-3 mt-2 mb-3 ${
                                                templateHeadersList.buttons
                                                  .length > 2
                                                  ? "flex-wrap"
                                                  : ""
                                              }`}
                                            >
                                              {templateHeadersList.buttons.map(
                                                (button, index) => (
                                                  <a
                                                    key={index}
                                                    href={button.url}
                                                    className="btn btn-success d-block mt-2 small_button"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                      flex:
                                                        templateHeadersList
                                                          .buttons.length > 2
                                                          ? "1 1 calc(50% - 1.5rem)"
                                                          : "unset",
                                                    }}
                                                  >
                                                    {button.text}
                                                  </a>
                                                )
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-end p-3">
                      <button type="submit" className="btn btn-primary">
                        Update
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignScheduleEditForm;
